<template>
    <div class="report_period_wrapper">
                                    <ValidationObserver v-slot="{ handleSubmit }">

        <CCard>
            <CCardHeader class="card-header grey-header d-flex mob-flex-column ai-center">
                <CRow class="flex-flow-column">
                    <CCol>
                        <strong>
                            {{
                            isViewOnly ? $t("deposit.sysStmtTitle") :$t("deposit.sysTitle")
                            }}
                        </strong>
                    </CCol>
                    <p class="desc">{{ isViewOnly ? $t("deposit.sysStmtdesc") : $t("deposit.sysDesc") }}</p>

                </CRow>

                <div class="generate-ex-btn" v-if="lsPostpaidStatements.length!=0 || lsPaymentStatements.length!=0"><img
                        src="@imgPath/img/svg/icons/excle-icon.svg"
                        alt

                        @click="toggleJsonExcelModal()"
                />

                </div>

            </CCardHeader>
            <!-- :custom-label="cityPickCustomeLabel" -->
            <!-- group-values="list"
                group-label="agencyName" -->


            <!--      <CCardHeader v-if="isSingleAgent">-->
            <!--        <CRow>-->
            <!--          <CCol>-->
            <!--            <CButton-->
            <!--              v-if="!isViewOnly"-->
            <!--              @click="-->
            <!--                selectAllPaymentStatements(agent.list),-->
            <!--                  (showExtendDueDateModal = false)-->
            <!--              "-->
            <!--            >-->
            <!--              {{ $t("deposit.payAll") }}-->
            <!--            </CButton>-->
            <!--          </CCol>-->

            <!--          <CCol>-->
            <!--            &lt;!&ndash; <CButton @click="onExtendDueDate()">-->
            <!--              {{ $t("deposit.extendDueDate") }}-->
            <!--            </CButton> &ndash;&gt;-->
            <!--          </CCol>-->
            <!--          <CCol-->
            <!--            style="padding-bottom: 20px;"-->
            <!--            class="d-flex justify-content-end"-->
            <!--          >-->
            <!--            <CButton v-if="isViewOnly"  class="">-->
            <!--              {{ $t("deposit.print") }}-->
            <!--            </CButton>-->
            <!--            <CButton v-else @click="sortStatements()" class="updown">-->
            <!--              {{ $t("deposit.sort") }}-->
            <!--            </CButton>-->
            <!--          </CCol>-->
            <!--        </CRow>-->
            <!--      </CCardHeader>-->

            <CCardBody>
                <div class="report_period_wrppaer_main">
                    <div class="top_row_sections">
                        <div class="agency_name no-50per-dev-select position-relative d-flex">
                            <div class="mr-15px w-100">


                                <div
                                        v-if="!isViewOnly&&  lsAllPostPaidAgents && lsAllPostPaidAgents.length"
                                        class="multiselect-assignprice"
                                >
                                    <label for class="title d-flex justify-content-between max-w-400">
                                        <strong>{{ $t("deposit.select") }}</strong>
                                    </label>
                                    <multiselect
                                            v-if="!isViewOnly&&  lsAllPostPaidAgents && lsAllPostPaidAgents.length"
                                            v-model="agent"
                                            :searchable="true"
                                            :showLabels="false"
                                            :label="'agencyName'"
                                            :options="lsAllPostPaidAgents"
                                            :track-by="'b2bid'"
                                            :disabled="false"
                                            :allow-empty="false"
                                            :isMultiple="false"
                                            :custom-label="agencyNameWithCode"
                                            @input="onAgentChange"
                                            class="bs-input"
                                            @open="toggleDatePicker"
                                    >
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="d-flex cagent-selected">
                                                <span class>{{ props.option["agencyName"] }}</span>
                                                <div
                                                        class="right"
                                                        v-if="props.option['b2bCode']"
                                                >({{ props.option["b2bCode"] }})
                                                </div>
                                            </div>
                                        </template>

                                        <template slot="option" slot-scope="props">
                                            <div class="d-flex">
                                                <strong class="w-50 txt-over-ellips">
                                                    {{
                                                    props.option["agencyName"]
                                                    }}
                                                </strong>
                                                <span class="text-right ml-auto w-50 txt-over-ellips">
                        {{
                        props.option["b2bCode"]
                        }}
                      </span>
                                            </div>
                                        </template>
                                        <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                                    </multiselect>
                                    <!--                  <span v-if="isSingleAgent" @click="clearAgent" class="clear_statement">clear</span>-->

                                </div>

                                <div v-else class="multiselect-assignprice position-relative">
                                    <cAgent class="multiselect bs-input inner-label-bold"
                                            :isAll="true"
                                            @input="onAllAgentChange"
                                            :agentType="allAgent.type"
                                            v-model="allAgent.details"
                                            :label="$t('deposit.select')"
                                            :isMultiple="false"
                                            @openCAgent="toggleDatePicker"
                                    ></cAgent>
                                    <!--                  <span v-if="isSingleAgent" @click="clearAgent" class="clear_statement"><img src="@imgPath/img/svg/icons/red-circle-cross.svg" alt=""></span>-->
                                </div>


                            </div>
                            <div class="multiselect-assignprice w-100">
                                <label for class="title d-flex justify-content-between max-w-400 ">
                                    <strong>{{$t('agentDeposit.statementNo')}}</strong> <span v-if="selStatement" @click="clearStatementNoDp"
                                                                        class="clear_statement">{{$t('agentDeposit.clear')}}</span>
                                </label>
                                <div class="multiselect bs-input" v-if="isShowStatementDp">


                                    <multiselect
                                            :allow-empty="false"
                                            :showLabels="false"
                                            :clearOnSelect="false"
                                            v-model="selStatement"
                                            :options="isSingleAgent?getStatementNoOptionLs():lsStatementNo"
                                            :multiple="false"
                                            :group-select="false"
                                            :placeholder="'Statement No.'"
                                            track-by="statementNo"
                                            v-on:input="onFilterByStatementNo"
                                            :custom-label="statementCustomLabel"

                                            :searchable="true"
                                            @open="toggleDatePicker"

                                    >
                                        <template
                                                slot="singleLabel"
                                                slot-scope="{ option }"
                                        >{{ option.statementNo}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div>
                                                <span v-if="props.option.$isLabel">{{ props.option.$groupLabel.value }}</span>
                                                <span v-else>
                      {{ props.option.statementNo}}
                                                    <!-- <strong
  v-if="props.option.statementNo"
  class="right"
  >{{ props.option.statementNo }}</strong> -->
                    </span>
                                            </div>
                                        </template>
                                        <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                                    </multiselect>
                                </div>
                            </div>


                        </div>

                        <div class="report_date">
                            <div class="report_date_wrapper">
                                <div class>
                                    <div>
                                        <label for class="title">
                                            <strong>{{ $t("deposit.rpFrom") }}</strong>
                                        </label>

                                        <div class="d-flex ">
                                            <!-- <HotelDatePicker
                                                    :closeDatepickerOnClickOutside="true"
                                                    :minNights="0"
                                                    :startingDateValue="getInitialReportDate()"
                                                    :startDate="null"
                                                    :endingDateValue="getFinalReportDate()"
                                                    :i18n="assigni18nObjByLang()"
                                                  
                                                    @check-in-changed="setReportFromDate"
                                                    @check-out-changed="setReportToDate"
                                                    :showYear="true"
                                                    :displayClearButton="false"
                                                    :hoveringTooltip="false"
                                            /> -->
                                            <div class="ext-date-wrapper box-shadow left">
                                                 <v-md-date-range-picker :ref="'datePicker'"
    :start-date="postpaidStatement.fromDate?postpaidStatement.fromDate.toString():new Date().toString()"
    :end-date="postpaidStatement.toDate?postpaidStatement.toDate.toString():new Date().toString()"
    :autoApply="true"
    :showYearSelect="true"
    :maxYear="getMaxYear()"
    :minYear="getMinYear()"
    @change="onChangeDate"
  >
  <template slot="input">
       <datePickerInput :fromDate="postpaidStatement.fromDate?postpaidStatement.fromDate:null" :toDate="postpaidStatement.toDate?postpaidStatement.toDate:null" :fromLabel="$t('deposit.fromLabel')" :toLabel="$t('deposit.toLabel')"/>
    
  </template>
  </v-md-date-range-picker></div>
                                            <CButton
                                                    @click="onReportDataChange()"
                                                    class="filter-btn-cus"
                                            >{{ $t("deposit.apply") }}
                                            </CButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="page-controllers">
                        <div class="d-flex align-item-center per-item"><span class="align-item-center d-flex">Items per page:</span>
                            <select v-model="cSystemDepositWatchList.itemsPerPage" class="form-control">
                                <option v-for="itemsPerPage in cSystemDepositWatchList.lsItemsPerPage"
                                        :key="itemsPerPage" :value="itemsPerPage">{{itemsPerPage}}
                                </option>

                            </select></div>
                        <div class="d-flex align-item-center">
                            <cPaginationLenOption :paginationWatchLs="cSystemDepositWatchList"/>
                            <CPagination
                                    :activePage.sync="cSystemDepositWatchList.currentPageNum"
                                    :pages="getTotalPages()"
                                    size=""
                                    align="center"
                            />
                        </div>

                    </div>

                    <div class="filter-row-wrapper">
                        <div class="indicators">

                             <div class="color_indicator" v-if="isSingleAgent&&!isViewOnly">
                                <!-- <div class="indi paid" v-if="isViewOnly">
                                    <span>{{ $t("deposit.paid") }}</span>
                                    <span 
                                          class="badge badge-primary">{{getStatusCountForAgent(POSTPAID_STATEMENT_STATUS.PAID)}}</span>
                                </div> -->
                                <div class="indi unpaid" v-c-tooltip.hover="{content:$t('agentDeposit.numOfUnpaidStatements')}">
                                    <span>{{ $t("deposit.unpaid") }}</span>
                                    <span 
                                          class="badge badge-primary">{{getStatusCountForAgent(POSTPAID_STATEMENT_STATUS.NEW)}}</span>
                                </div>
                                <div class="indi partial_paid" v-c-tooltip.hover="{content:$t('agentDeposit.numOfPartialPaid')}">
                                    <span>{{ $t("deposit.partialPaid") }}</span>
                                    <span 
                                          class="badge badge-primary">{{getStatusCountForAgent(POSTPAID_STATEMENT_STATUS.PARTIALLY_PAID)}}</span>
                                </div>
                            </div>
                            <div class="color_indicator" v-else>
                                <div class="indi paid" v-if="isViewOnly" v-c-tooltip.hover="{content:$t('agentDeposit.numOfPaid')}">
                                    <span>{{ $t("deposit.paid") }}</span>
                                    <span v-if="postPaidCount&&postPaidCount.hasOwnProperty('selected_paid')&&!isSingleAgent"
                                          class="badge badge-primary">{{Number(postPaidCount.selected_paid)+Number(postPaidCount.selected_noneedtopay)}}</span>
                                </div>
                                <div class="indi unpaid" v-c-tooltip.hover="{content:$t('agentDeposit.numOfUnpaidStatements')}">
                                    <span>{{ $t("deposit.unpaid") }}</span>
                                    <span v-if="postPaidCount&&postPaidCount.selected_unpaid&&!isSingleAgent"
                                          class="badge badge-primary">{{postPaidCount.selected_unpaid}}</span>
                                </div>
                                <div class="indi partial_paid" v-c-tooltip.hover="{content:$t('agentDeposit.numOfPartialPaid')}">
                                    <span>{{ $t("deposit.partialPaid") }}</span>
                                    <span v-if="postPaidCount&&postPaidCount.selected_partialpaid&&!isSingleAgent"
                                          class="badge badge-primary">{{postPaidCount.selected_partialpaid}}</span>
                                </div>
                            </div>


                            <div class="d-flex agent-count" v-if="!isSingleAgent" v-c-tooltip.hover="{content:$t('deposit.numOfAgentFound')}">


                                <span>{{ $t("deposit.agentFound") }}</span>
                                <span v-if="postPaidCount&&postPaidCount.selected_agentfound"
                                      class="badge badge-primary">{{postPaidCount.selected_agentfound}}</span>
                            </div>
                        </div>
                        <!--            <div v-if="!isSingleAgent">-->
                        <!-- <span>{{ $t("deposit.agentFound") }}</span>-->
                        <!--                  <span v-if="postPaidCount&&postPaidCount.selected_agentfound">{{postPaidCount.selected_agentfound}}</span>-->
                        <!--            </div>-->


                        <!--              <CButton v-if="isViewOnly" @click="toggleJsonExcelModal()" class="">-->
                        <!--              {{ $t("deposit.print") }}-->
                        <!--            </CButton>-->

                        <div class="filters">

                            <div class="label-t">
                                <div class="checkbox-all d-flex">
                                    <!-- <div class="check-box mr-15px" v-if="isSingleAgent">
                    <input
                      v-if="!isViewOnly"
                      v-model="paymentDet.isAll "
                      @input="!paymentDet.isAll?     selectAllPaymentStatements(agent.list)
                     :clearPaymentStatements()"
                      type="checkbox"
                      id="select_all"
                      class="d-none"
                    />

                    <label for="select_all" v-if="!isViewOnly">{{ $t("deposit.payAll") }}</label>
                  </div> -->

                                    <div class="checkbox" >
                                        <input
                                                class="d-none"
                                                v-model="postpaid.isPastDueDate"
                                                type="checkbox"
                                                @change="isSingleAgent?filterStatements(postpaid):filterPostpaidStatements(postpaid)"
                                                id="balance-due_checkbox"
                                        />
                                        <label for="balance-due_checkbox" v-c-tooltip.hover="{content:$t('agentDeposit.numOfOutstanding')}">{{$t('deposit.outstanding')}}</label>
                                        <span v-if="postPaidCount&&postPaidCount.selected_overdueue&&!isSingleAgent"
                                              class="badge badge-primary">{{postPaidCount.selected_overdueue}}</span>


                                    </div>
                                </div>
                                <!--                <img src="https://image.flaticon.com/icons/svg/565/565320.svg" alt />-->
                                <!--                <span>{{ $t("deposit.sort") }}</span>-->
                                <span v-if="!isViewOnly" class="filter-statement" :class="{active:isAscSort}" @click="sortStatements()">{{$t('deposit.statementDate')}}</span>
                            </div>
                            <div v-if="isViewOnly " class="d-flex">
                                <div class="checkbox ">
                                <input
                                        v-model="postpaid.isPaid"
                                        type="checkbox"
                                        class="d-none"
                                        @change="isSingleAgent?filterStatements(postpaid):filterPostpaidStatements(postpaid)"
                                        id="paid-checkbox"
                                />

                                <label for="paid-checkbox" v-c-tooltip.hover="{content:$t('agentDeposit.allPaid')}">{{ $t("deposit.paid") }}</label>
                                </div>
                                  <span v-if="postPaidCount&&postPaidCount.hasOwnProperty('selected_paid')&&!isSingleAgent"
                                              class="badge badge-primary">{{Number(postPaidCount.selected_paid)+Number(postPaidCount.selected_noneedtopay)}}</span>


                            </div>
                            <!-- <div v-if="!isSingleAgent  && isViewOnly " class="checkbox">
                <input
                  v-model="postpaid.isDueBalance"
                  type="checkbox"
                  @change="filterPostpaidStatements(postpaid)"
                  id="balance-due_checkbox"
                />
                <label for="balance-due_checkbox">{{ $t("deposit.balDue") }}</label> -->
                            <!--              <CCol-->
                            <!--                      style="padding-bottom: 20px;"-->
                            <!--                      class="d-flex justify-content-end"-->
                            <!--              >-->
                            <!--                <CButton v-if="isViewOnly" class="">-->
                            <!--                  {{ $t("deposit.print") }}-->
                            <!--                </CButton>-->
                            <!--                <CButton v-else @click="sortStatements()" class="updown">-->
                            <!--                  {{ $t("deposit.sort") }}-->
                            <!--                </CButton>-->
                            <!--              </CCol>-->
                            <!-- </div> -->

                            <!--              <img-->
                            <!--                src="@imgPath/img/svg/icons/excle-icon.svg"-->
                            <!--                alt-->
                            <!--                -->
                            <!--                @click="toggleJsonExcelModal()"-->
                            <!--                class="export-icon-btn"-->
                            <!--              />-->
                        </div>
                    </div>

                    <!--        <CRow>-->

                    <!--          <CCol col="3">-->
                    <!--            <multiselect-->
                    <!--                    v-if="lsPostpaidTypes && lsPostpaidTypes.length"-->
                    <!--                    v-model="postpaid.type"-->
                    <!--                    :searchable="true"-->
                    <!--                    :label="'name'"-->
                    <!--                    :options="lsPostpaidTypes"-->
                    <!--                    :track-by="'value'"-->
                    <!--                    :disabled="false"-->
                    <!--                    :allow-empty="false"-->
                    <!--                    :isMultiple="false"-->
                    <!--                    @input="filterPostpaidStatements(postpaid)"-->
                    <!--            >-->
                    <!--            </multiselect>-->
                    <!--          </CCol>-->

                    <!--        </CRow>-->

                    <section  v-if="isSingleAgent">
                        <div  v-if="agent && agent.list && agent.list.length">
                            <transition-group name="flip-list" tag="ul">
                            <div
                                    v-for="(statement, sindex) in agent.list"
                                    :key="sindex+'systemDep'"

                            >
                                <div class="card assign pricing-card" v-if="getStatementsCountForAgntView(sindex)">
                                    <div class="card-head d-flex ai-center">
                                        <div class="align-left a-name agency-name">
                                            <h3>{{ agent.agencyName }}</h3>
                                            <span>{{ agent.b2bCode }}</span>
                                        </div>
                                        <div class="align-left a-name s-date">
                                            <p>{{ $t("deposit.rpDate") }}</p>
                                            <span>
                      {{ statement.fromDate|formatDate }}
                      {{$t('deposit.to')}}
                      {{ statement.toDate|formatDate}}
                    </span>
                                        </div>
                                        <div class="align-left a-name over-d-date" v-if="getOverDueDays(statement)">
<p>
    {{ $t("deposit.paymentDueBy") }}
</p>
                    <span>
                      {{ getOverDueDays(statement) }}

                    </span>
                                        </div>
                                        <div class="align-right atn-btn" v-if="getExtendDueDateBtn(statement)">
                                            <button
                                                    v-if="!isViewOnly"
                                                    @click="onExtendDueDate(agent, statement)"
                                                    data-v-c2da5fea
                                                    type="button"
                                                    color="info"
                                                    class="btn extendduedate-btn mob-w100"
                                            >{{ $t("deposit.extend") }}
                                            </button>
                                                </div>
                                            <button
                                                        v-if="!isViewOnly && !lsPaymentStatements.length"
                                                        @click="onPay(agent, statement)"
                                                        data-v-c2da5fea
                                                        type="button"
                                                        color="info"
                                                        class="btn extendduedate-btn mob-w100"
                                                        style="margin-left: 5px;"
                                                >{{ $t("deposit.payBtn") }}
                                                </button>



                                       
                                    </div>

                                    <div></div>

                                    <div class="card-body pb-0px report_table_div-section">
                                        <table>
                                            <thead>
                                            <th>
                                                <div>{{$t('deposit.status')}}</div>
                                            </th>
                                            <th
                                                    :key="titIndex"
                                                    v-for="(title, titIndex) in Object.keys(
                          getStatementTitles()
                        )"
                                            >{{ title == 'action' &&isViewOnly?null:$t(`statementTitle.${title}`) }}
                                            </th>
                                               
                                               <th   v-if="lsPaymentStatements&&  lsPaymentStatements.length>0">
                                                   <div>
                                                      
                                                  
                                                 {{ $t("deposit.amntToPayment")}}
                                                     </div>
                                               </th>
                                              

                                            
                                                <th>

                                               </th>
                                               

                                            </thead>
                                            <tbody>
                                            <tr
                                                    :class="{
                          highLight: lsPaymentStatements.includes(
                            stmntCurr.statementNo
                          )
                        }"
                                                    v-for="(stmntCurr, stIndex) in getStatementCurrencies(
                          statement
                        )"
                                                    :key="stIndex"
                                            >
                                                <td class="color_indicator_sub">
                                                    <div
                                                            class="indi"
                                                            :class="{'paid':stmntCurr.statementStatus ==
                                    POSTPAID_STATEMENT_STATUS.PAID ||POSTPAID_STATEMENT_STATUS.EMPTY,'partial_paid':stmntCurr.statementStatus ==
                                    POSTPAID_STATEMENT_STATUS.PARTIALLY_PAID,'unpaid':stmntCurr.statementStatus ==
                                    POSTPAID_STATEMENT_STATUS.NEW}"
                                                    ></div>
                                                </td>
                                                <!-- <td>
                          <div class="checkbox-all-table">
                            <input
                              v-if="
                                !isViewOnly &&
                                  statement[stmntCurr.name].statementStatus !=
                                    POSTPAID_STATEMENT_STATUS.EMPTY &&
                                  statement[stmntCurr.name].statementStatus !=
                                    POSTPAID_STATEMENT_STATUS.PAID
                              "
                              type="checkbox"
                              :checked="
                                lsPaymentStatements.includes(
                                  stmntCurr.statementNo
                                )
                              "
                              @input="
                                selectPaymentStatements(stmntCurr.statementNo)
                              "
                              :id="'check_a_in' + stIndex+sindex"
                            />

                            <input
                              v-else-if="isViewOnly"
                              type="checkbox"
                              :id="'check_a_in' + stIndex+sindex"
                              :checked="
                                lsPrintableStatements.includes(
                                  stmntCurr.statementNo
                                )
                              "
                              @input="
                                selectPrintStatements(stmntCurr.statementNo)
                              "
                            />
                            <label :for="'check_a_in' + stIndex+sindex"></label>
                          </div>
                        </td>-->
                                                <td
                                                        :key="titIndex"
                                                        v-for="(title, titIndex) in Object.keys(
                            getStatementTitles()
                          )"
                                                >
                                                    <!-- <div>


                            <input
                              v-else-if="isViewOnly"
                              type="checkbox"
                              :id="'check_a_in' + stmntCurr.statementNo"
                              :checked="
                                lsPrintableStatements.includes(
                                  stmntCurr.statementNo
                                )
                              "
                              @input="
                                selectPrintStatements(stmntCurr.statementNo)
                              "
                            />
                             {{stmntCurr.statementNo}}
                          </div>-->

                                                    <p
                                                            v-if="title != 'action' "
                                                            :class="{'hyperlink-c':title=='dueDate'|| (title=='invoice'&&stmntCurr[title]!=0)||((title == 'paidAmount'||title =='dueAmount') &&stmntCurr.statementStatus !=
                                  POSTPAID_STATEMENT_STATUS.NEW &&  stmntCurr.statementStatus !=
                                  POSTPAID_STATEMENT_STATUS.EMPTY)}"
                                                    >
                                                        <!-- title == 'paidAmount' &&
                                (stmntCurr.statementStatus !=
                                    POSTPAID_STATEMENT_STATUS.NEW  && stmntCurr.statementStatus != POSTPAID_STATEMENT_STATUS.EMPTY)
                                  ? getPaymentHistory(
                                      stmntCurr.statementNo,
                                      agent.b2bid,
                                      agent
                                    )
                            : null-->
                                                        <label
                                                                @click="onClickHyperLink(title,stmntCurr,agent)

                              "
                                                                v-if="
                                title == 'dueAmount' ||
                                  title == 'paidAmount' ||
                                  title == 'balanceDue' || title=='invoice'
                              "
                                                        >
                                                            {{
                                                            title=='invoice'?stmntCurr[title]:stmntCurr[title]
                                                            }}
                                                        </label>

                                                        <label
                                                                v-else @click="onClickHyperLink(title,stmntCurr,agent)"
                                                                :class="{'overdue-class':title=='dueDate'&&getOverDueClass(stmntCurr[title],stmntCurr)}"
                                                                :style="{color:title=='dueDate'&&getOverDueClass(stmntCurr[title],stmntCurr)?'red':''}"
                                                        >
                                                            {{
                                                            title == "dueDate"?stmntCurr[title]
                                                            ? $options.filters.formatDate( stmntCurr[title]):''
                                                            : stmntCurr[title]
                                                            }}
                                                        </label>
                                                    </p>

                                                    <!--        <CButton
                            v-else-if="isViewOnly"
                            :disabled="lsPrintableStatements.length > 0"
                            @click="
                              selectPrintStatements(stmntCurr.statementNo)
                            "
                            class="btn btn filter-btn-cus success"
                          >
                            {{ $t("deposit.print") }}
                          </CButton>-->
                                                    <CBadge
                                                            v-else-if="!isViewOnly &&
                              statement[stmntCurr.name].statementStatus ==
                                POSTPAID_STATEMENT_STATUS.PAID
                            "
                                                            color="success"
                                                    >{{ $t("deposit.paid") }}
                                                    </CBadge>

                                                    <CButton
                                                            :disabled="
                              lsPaymentStatements.includes(
                                stmntCurr.statementNo
                              )
                            "
                                                            v-else-if="!isViewOnly &&
                              statement[stmntCurr.name].statementStatus !=
                                POSTPAID_STATEMENT_STATUS.EMPTY
                            "
                                                            @click="
                              selectPaymentStatements(stmntCurr.statementNo,stmntCurr)
                            "
                                                            class="btn btn filter-btn-cus success"
                                                    >{{ $t("deposit.pay") }}
                                                    </CButton>
                                                </td>









                                                    <td>
                                                  
                                                    <cTextInputComponent v-if="lsPaymentStatements&&  lsPaymentStatements.includes(
                                  stmntCurr.statementNo 
                                )"  :rules="'required|noInitialSpace|onlynumber|validDecimal|no_zero|max_value:'+ $options.filters.currencyFormat( stmntCurr.balanceDue,'USD')"
                                 :isAmountField="true"
                                  class="inner-label-none max-w-100px"

                                 @input=" onNewDueAmount"
                
                                 v-model="statement[stmntCurr.name].newBalAmount"
                                 :toEmit="true"
                                                                 @caughtError="scrollToElement"
                                                                  :id="'AmounttopayData'" 
                                                                  :ref="'AmounttopayData'">
                                 

                                                    </cTextInputComponent>
                                                 
                                                </td>
                                               

                                                <td
                                                        style="    min-height: 38px;"
                                                        class="checkbox-all-table max-w-100px"
                                                        v-if="
                                !isViewOnly &&
                                  statement[stmntCurr.name].statementStatus !=
                                    POSTPAID_STATEMENT_STATUS.EMPTY &&
                                  statement[stmntCurr.name].statementStatus !=
                                    POSTPAID_STATEMENT_STATUS.PAID
                              "
                                                >
                                                    <div class="d-flex m-auto align-item-center justify-center">
                                                        <input
                                                                type="checkbox"
                                                                :checked="
                                lsPaymentStatements.includes(
                                  stmntCurr.statementNo
                                )
                              "
                                                                @input="
                                selectPaymentStatements(stmntCurr.statementNo,stmntCurr)
                              "
                                                                :id="'check_a_in' + stmntCurr.statementNo"
                                                        />

                                                        <label :for="'check_a_in' + stmntCurr.statementNo"></label>
                                                    </div>
                                                </td>

                                                
                                            
                                            </tr>
                                            </tbody>
                                        </table>

                                        <!--              <CRow>-->
                                        <!--                <CCol> </CCol>-->
                                        <!--                <CCol-->
                                        <!--                  :key="titIndex"-->
                                        <!--                  v-for="(title, titIndex) in Object.keys(getStatementTitles())"-->
                                        <!--                >-->
                                        <!--                  <h5 style="white-space: nowrap">-->
                                        <!--                    {{ $t(`statementTitle.${title}`) }}-->
                                        <!--                  </h5>-->

                                        <!--                  <br />-->
                                        <!--                </CCol>-->
                                        <!--              </CRow>-->

                                        <!--              <CRow-->
                                        <!--                :class="{-->
                                        <!--                  highLight: lsPaymentStatements.includes(stmntCurr.statementNo)-->
                                        <!--                }"-->
                                        <!--                v-for="(stmntCurr, stIndex) in getStatementCurrencies(-->
                                        <!--                  statement-->
                                        <!--                )"-->
                                        <!--                :key="stIndex"-->
                                        <!--              >-->
                                        <!--                <CCol>-->

                                        <!--                </CCol>-->
                                        <!--                <CCol-->

                                        <!--                >-->

                                        <!--                  <br />-->
                                        <!--                  <br />-->
                                        <!--                </CCol>-->
                                        <!--              </CRow>-->
                                        <!--              <br />-->
                                    </div>
                                </div>
                            </div>
                            </transition-group>
                        </div>
                        
                        <section v-else class="no-result-section">
                            <strong>{{ $t("deposit.noResult") }}</strong>
                        </section>


                        <div v-if="showExtendDueDateModal">
                            <div class="bclear-popup">
                                <div tabindex="-1" role="dialog" class="modal overflow-auto fade show d-block">
                                    <div role="document" class="modal-dialog modal-dialog-centered">
                                        <div class="modal-content">
                                            <header class="card-header position-relative">
                                                <div class="d-flex ai-center">
                                                    <img
                                                            src="@imgPath/img/svg/icons/blue-icons/calendar-icon.svg"
                                                            alt
                                                            class="title_icon"
                                                    />
                                                    <div style="padding-left: 15px;">{{ $t("deposit.extendDuedate") }}</div>
                                                </div>
                                                <div class="close" @click="showExtendDueDateModal = false">
                                                    <img src="@imgPath/img/svg/icons/cross-radius.svg" alt/>
                                                </div>
                                            </header>
                                            <div class="card-body pb-0px" v-if="stmntExtendDet">
                                                <div class="wrap">
                                                    <div class="des">{{ $t("deposit.extendDesc") }}</div>
                                                    <div class="options-wrap">
                                                        <div class="option curreDueDate">
                                                            <label for class="title">{{ $t("deposit.currDueDate")
                                                                }}</label>
                                                            <div class="value">
                                                                {{ stmntExtendDet.currDueDate|formatDate
                                                                }}
                                                            </div>
                                                        </div>
                                                        <div class="option date-wrapper_check">
                                                            <label for class="title">
                                                                {{ $t("deposit.extendDueDate") }}
                                                                <span>
                                  <div class="icon">
                                    <img
                                            src="@imgPath/img/svg/icons/blue-icons/edit-box.svg"
                                            alt
                                            width="20px"
                                    />
                                  </div>
                                </span>
                                                            </label>
                                                            <div class>
                                                                <!-- :startingDateValue="
                                    stmntExtendDet.currDueDate
                                "-->
                                                                <HotelDatePicker
                                                                        :closeDatepickerOnClickOutside="true"
                                                                        v-if="stmntExtendDet.currDueDate"
                                                                        :startDate="getExtendStartDateValue(stmntExtendDet.currDueDate)"
                                                                        :singleDaySelection="true"
                                                                        :format='DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT'
                                                                        :minNights="0"
                                                                        :i18n="assigni18nObjByLang(stmntExtendDet.newDueDate)"
                                                                        :enableCheckout="false"
                                                                        :showYear="true"
                                                                        :endDate="getExtendEndDateValue(stmntExtendDet)"
                                                                        :displayClearButton="false"
                                                                        :hoveringTooltip="false"
                                                                        @check-in-changed="setNewDueDate"
                                                                ></HotelDatePicker>
                                                            </div>
                                                        </div>
                                                        <div class="option">
                                                            <label for class="title">{{ $t("deposit.dueStmnts")
                                                                }}</label>
                                                            <div
                                                                    class="value"
                                                                    v-if="
                                  stmntExtendDet.lsStmnts &&
                                    stmntExtendDet.lsStmnts.length
                                "
                                                            >{{ stmntExtendDet.lsStmnts.length }}
                                                            </div>
                                                        </div>
                                                        <div class="option">
                                                            <label for class="title">{{ $t("deposit.dueAmount")
                                                                }}</label>
                                                            <div
                                                                    class="value"
                                                                    v-if="
                                  stmntExtendDet &&
                                    stmntExtendDet.lsStmntsCurrencies &&
                                    stmntExtendDet.lsStmntsCurrencies.length
                                "
                                                            >
                                                                <div class="row">
                                                                    <div class="col-md-12">
                                                                        <div class="d-flex currency-extend-date">
                                                                            <table>
                                                                                <tbody>
                                                                                <tr
                                                                                        v-for="(stmntCurr,index) in stmntExtendDet.lsStmntsCurrencies"
                                                                                        :key="index + 'li'"
                                                                                >
                                                                                    <td>
                                                                                        <label for="">{{
                                                                                            stmntCurr.currency
                                                                                            }}</label>
                                                                                    </td>
                                                                                    <td>
                                                                                    
                                                                                        <strong>
                                                                                            {{
                                                                                            stmntCurr.balAmount
                                                                                            }}
                                                                                        </strong>
                                                                                    </td>
                                                                                </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                                <div class="row"></div>
                                                <div class="row">
                                                    <span></span>
                                                </div>
                                            </div>
                                            <footer class="card-footer">
                                                <div class="d-flex justify-content-end">
                                                    <button
                                                            type="submit"
                                                            class="btn primary-btn"
                                                            @click="toggleConfirmModal(),showExtendDueDateModal=false"
                                                    >{{ $t("deposit.apply") }}
                                                    </button>
                                                </div>
                                            </footer>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-backdrop fade show"></div>
                            </div>

                            <!-- <CCard class="d-flex justify-content-center">
                <CCardBody v-if="stmntExtendDet">
                  <CRow>
                    <CCol md="6">
                      <strong>
                        {{ $t("deposit.dueStmnts") }}
                      </strong>
                    </CCol>
                    <CCol
                      md="6"
                      v-if="
                        stmntExtendDet.lsStmnts &&
                          stmntExtendDet.lsStmnts.length
                      "
                    >
                      {{ stmntExtendDet.lsStmnts.length }}
                    </CCol>
                  </CRow>
                  <br />

                  <CRow>
                    <CCol md="6">
                      <strong>
                        {{ $t("deposit.dueAmount") }}
                      </strong>
                    </CCol>

                    <CCol
                      md="6"
                      v-if="
                        stmntExtendDet &&
                          stmntExtendDet.lsStmntsCurrencies &&
                          stmntExtendDet.lsStmntsCurrencies.length
                      "
                    >
                      <div class="row">
                        <div class="col-md-2">
                          <div
                            class="d-flex"
                            v-for="(stmntCurr,
                            index) in stmntExtendDet.lsStmntsCurrencies"
                            :key="index + 'li'"
                          >
                            <strong>
                              {{ stmntCurr.currency }}
                            </strong>


                            <label>
                              {{ stmntCurr.balAmount }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </CCol>
                  </CRow>
                  <br />

                  <CRow>
                    <CCol md="6">
                      <strong>
                        {{ $t("deposit.currDueDate") }}
                      </strong>
                    </CCol>

                    <CCol md="6">
                      {{ formatDate(stmntExtendDet.currDueDate) }}
                    </CCol>
                  </CRow>
                  <br />

                  <CRow>
                    <CCol md="6">
                      <strong>
                        {{ $t("deposit.extendDueDate") }}
                      </strong>
                    </CCol>
                    <CCol md="6">
                      <HotelDatePicker
                        v-if="stmntExtendDet.currDueDate"
                        :singleDaySelection="true"
                        :startingDateValue="stmntExtendDet.currDueDate"
                        :minNights="0"
                        :i18n="assigni18nObjByLang()"
                        :enableCheckout="false"
                        :showYear="true"
                        :endingDate="new Date(null)"
                        :displayClearButton="false"
                        :hoveringTooltip="false"
                        @check-in-changed="setNewDueDate"
                      >
                      </HotelDatePicker>
                    </CCol>
                  </CRow>
                </CCardBody>

                <CCardFooter class="d-flex justify-content-end">
                  <CRow>
                    <CCol>
                      <CAlert v-if="alertValue" show color="danger"
                        >{{ alertValue }}
                      </CAlert>
                    </CCol>
                    <CCol>
                      <CButton
                        @click="showExtendDueDateModal = false"
                        color="danger"
                      >
                        {{ $t("deposit.cancel") }}
                      </CButton>
                    </CCol>
                    <CCol>
                      <CButton color="success" @click="toggleConfirmModal()">
                        {{ $t("deposit.apply") }}
                      </CButton>
                    </CCol>
                  </CRow>
                </CCardFooter>
              </CCard>-->
                        </div>

                        <div v-else-if="lsPaymentStatements && lsPaymentStatements.length">
                            <!-- <ValidationObserver v-slot="{ handleSubmit }"> -->
                                <div class="payment_postpaid">
                                     <!-- @submit.prevent="handleSubmit(toggleConfirmModal)" -->
                                    <CForm
                                            class="card assign pricing-card"
                                           
                                            autocomplete="off"
                                    >
                                        <CRow class="mb-20px">
                                            <div class="col-md-4 mrl-auto">
                                                <div class="payment-currency">
                                                    <cOrgCurrencyDp  v-if="isOrgCurrencyDpShow && GET_ORG_CURRENCY_RES"
                                                            v-model="paymentCurrency"
                                                          :defaultCurrency="selCurrencyCode"
                                                            :ctrlCode="'id'"
                                                            :isShowCode="true"
                                                            :isMultiple="false"
                                                            :isSearchable="false"
                                                            :isAllowEmpty="false"
                                                            rules="required"
                                                            :label="$t('deposit.DdCurrency')"
                                                            @input="onPaymentCurrencyChange"
                                                            class="bs-input"
                                                    ></cOrgCurrencyDp>
                                                </div>
                                            </div>
                                        </CRow>
                                        <CRow class="table-wrapper ">
                                            <table class="w-100">
                                                <thead>
                                                <th>{{ $t("deposit.currency") }}</th>
                                                <th>{{ $t("deposit.dueAmount") }}</th>
                                                <th>{{ $t("deposit.sysExRate") }}</th>
                                                <th>{{ $t("deposit.chngExRate") }}</th>
                                                <th>{{ $t("deposit.convTotAmnt") }}</th>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(depCurr, index) in lsDepositCurrencies" :key="'mm' + index">
                                                    <td v-if="depCurr">
                                                        <div>{{ depCurr.currency }}</div>
                                                    </td>
                                                    <td v-if="depCurr">
                                                        <div>
                                                            

                                                            {{
                                                          
                                                            depCurr.balAmount.toString(),
                                                       
                                                            
                                                            }}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>{{ depCurr.sysExRate }}</div>
                                                    </td>
                                                    <td>
                                                        <div
                                                                v-if="
                                  depCurr &&
                                    depCurr.currency &&
                                    paymentCurrency &&
                                    paymentCurrency.currency_code &&
                                    depCurr.currency ==
                                      paymentCurrency.currency_code.code
                                "
                                                        >{{ 1 }}
                                                        </div>
                                                        <cTextInputComponent
                                                                v-else
                                                                :isAmountField="true"
                                                                v-model="depCurr['newExRate']"
                                                                rules="noInitialSpace|onlynumber|no_zero|validDecimal"
                                                                :min="0.00000000001"
                                                                class="input-edited inner-label-none remove_row_col"
                                                                @input="paymentDet.newAmount=null"
                                                        />
                                                    </td>
                                                    <td
                                                            v-if="
                                paymentCurrency && paymentCurrency.currency_code
                              "
                                                    >
                                                        <div>
                                                            <label>{{ paymentCurrency.currency_code.code }}</label>
                                                            {{
                                                            getDepositConvertedAmount(depCurr).toString()| formatNumber(
                                                            "USD"
                                                            )
                                                         
                                                            }}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <!--                    <tr  v-if="paymentCurrency && paymentCurrency.currency_code" class="total_tr border-top">-->
                                                <!--                      <td></td>-->
                                                <!--                      <td></td>-->
                                                <!--                      <td></td>-->
                                                <!--                      <td  v-if="paymentCurrency && paymentCurrency.currency_code"> <div class="space-div"> {{ $t("deposit.totalAmt") }}</div></td>-->
                                                <!--                      <td>-->

                                                <!--                        <strong-->
                                                <!--                                style="-->
                                                <!--      padding-right: 5px;"-->
                                                <!--                                v-if="paymentCurrency && paymentCurrency.currency_code"-->
                                                <!--                        >-->
                                                <!--                          {{ paymentCurrency.currency_code.code }}-->
                                                <!--                        </strong>-->

                                                <!--                        <span style="color:red">-->
                                                <!--                    {{-->
                                                <!--                      $options.filters.formatNumber(-->
                                                <!--                        getTotalDepsoitAmount(lsDepositCurrencies),-->
                                                <!--                        paymentCurrency.currency_code.code-->
                                                <!--                      )-->
                                                <!--                    }}-->
                                                <!--                  </span></td>-->
                                                <!--                    </tr>-->
                                                <!--                    <tr class="total_tr">-->
                                                <!--                      <td></td>-->
                                                <!--                      <td></td>-->
                                                <!--                      <td></td>-->
                                                <!--                      <td>  <div class="space-div">{{ $t("deposit.amntToPayment") }}</div></td>-->
                                                <!--                      <td></td>-->
                                                <!--                    </tr>-->
                                                </tbody>
                                            </table>
                                        </CRow>
                                        <!--              <CRow>-->
                                        <!--                <CCol>-->
                                        <!--                  <h5>-->
                                        <!--                    {{ $t("deposit.currency") }}-->
                                        <!--                  </h5>-->
                                        <!--                </CCol>-->
                                        <!--                <CCol>-->
                                        <!--                  <h5>-->
                                        <!--                    {{ $t("deposit.dueAmount") }}-->
                                        <!--                  </h5>-->
                                        <!--                </CCol>-->

                                        <!--                <CCol>-->
                                        <!--                  <h5>-->
                                        <!--                    {{ $t("deposit.sysExRate") }}-->
                                        <!--                  </h5>-->
                                        <!--                </CCol>-->

                                        <!--                <CCol>-->
                                        <!--                  <h5>-->
                                        <!--                    {{ $t("deposit.chngExRate") }}-->
                                        <!--                  </h5>-->
                                        <!--                </CCol>-->

                                        <!--                <CCol>-->
                                        <!--                  <h5>-->
                                        <!--                    {{ $t("deposit.convTotAmnt") }}-->
                                        <!--                  </h5>-->
                                        <!--                </CCol>-->
                                        <!--              </CRow>-->
                                        <!--                <br />-->

                                        <!--              <CRow-->
                                        <!--                v-for="(depCurr, index) in lsDepositCurrencies"-->
                                        <!--                :key="'mm' + index"-->
                                        <!--              >-->
                                        <!--                <CCol>-->
                                        <!--                  <h5 v-if="depCurr">-->
                                        <!--                    {{ depCurr.currency }}-->
                                        <!--                  </h5>-->
                                        <!--                </CCol>-->
                                        <!--                <br />-->
                                        <!--                <br />-->

                                        <!--                <CCol>-->
                                        <!--                  <h5>-->
                                        <!--                    {{-->
                                        <!--                      $options.filters.formatNumber(-->
                                        <!--                        depCurr.balAmount,-->
                                        <!--                        depCurr.currency-->
                                        <!--                      )-->
                                        <!--                    }}-->
                                        <!--                  </h5></CCol-->
                                        <!--                >-->
                                        <!--                <CCol>-->
                                        <!--                  <h5>-->
                                        <!--                    {{ depCurr.sysExRate }}-->
                                        <!--                  </h5>-->
                                        <!--                </CCol>-->
                                        <!--                <CCol>-->
                                        <!--                  <h5-->
                                        <!--                    v-if="-->
                                        <!--                      depCurr &&-->
                                        <!--                        depCurr.currency &&-->
                                        <!--                        paymentCurrency &&-->
                                        <!--                        paymentCurrency.currency_code &&-->
                                        <!--                        depCurr.currency == paymentCurrency.currency_code.code-->
                                        <!--                    "-->
                                        <!--                  >-->
                                        <!--                    {{ 1 }}-->
                                        <!--                  </h5>-->

                                        <!--                  <cTextInputComponent-->
                                        <!--                    v-else-->
                                        <!--                    :isAmountField="true"-->
                                        <!--                    v-model="depCurr['newExRate']"-->
                                        <!--                    rules="onlynumber|min_value:0.00000000001|validDecimal"-->
                                        <!--                    :min="0.00000000001"-->
                                        <!--                  />-->
                                        <!--                </CCol>-->

                                        <!--                <CCol v-if="paymentCurrency && paymentCurrency.currency_code">-->
                                        <!--                  <label>-->
                                        <!--                    {{ paymentCurrency.currency_code.code }}-->
                                        <!--                  </label>-->

                                        <!--                  {{-->
                                        <!--                    $options.filters.formatNumber(-->
                                        <!--                      getDepositConvertedAmount(depCurr),-->
                                        <!--                      paymentCurrency.currency_code.code-->
                                        <!--                    )-->
                                        <!--                  }}-->
                                        <!--                </CCol>-->
                                        <!--              </CRow>-->

                                        <CCardFooter>
                                            <!--                  <CRow class="d-flex justify-content-center">-->
                                            <!--                    <strong>-->
                                            <!--                      {{ $t("deposit.paymentDet") }}-->
                                            <!--                    </strong>-->
                                            <!--                  </CRow>-->
                                            <!--                  <br />-->
                                            <!--                  <CRow>-->
                                            <!--                    <CCol col="6">-->
                                            <!--                      <strong>-->
                                            <!--                        {{ $t("deposit.receivedDate") }}-->
                                            <!--                      </strong>-->
                                            <!--                    </CCol>-->

                                            <!--                    <CCol col="6">-->
                                            <!--                      <label for="">Received Date</label>-->
                                            <!--                      <HotelDatePicker-->
                                            <!--                              :startDate="null"-->
                                            <!--                              :endDate="new Date()"-->
                                            <!--                              :singleDaySelection="true"-->
                                            <!--                              :minNights="0"-->
                                            <!--                              :i18n="assigni18nObjByLang()"-->
                                            <!--                              :startingDateValue="paymentDet.recievedDate"-->
                                            <!--                              :endingDateValue="new Date()"-->
                                            <!--                              :showYear="true"-->
                                            <!--                              :displayClearButton="false"-->
                                            <!--                              :hoveringTooltip="false"-->
                                            <!--                              @check-in-changed="setPaymentDate"-->

                                            <!--                      >-->
                                            <!--                      </HotelDatePicker>-->
                                            <!--                    </CCol>-->
                                            <!--                  </CRow>-->

                                            <!--                  <CRow>-->
                                            <!--                    <CCol col="6">-->
                                            <!--                      <strong>-->
                                            <!--                        {{ $t("deposit.paymentMethod") }}-->
                                            <!--                      </strong>-->
                                            <!--                    </CCol>-->

                                            <!--                    <CCol col="6">-->
                                            <!--                      <label for="">Payment Method</label>-->
                                            <!--                      <cTextInputComponent-->
                                            <!--                              rules="required"-->
                                            <!--                              v-model="paymentDet.method"-->
                                            <!--                      >-->
                                            <!--                      </cTextInputComponent>-->
                                            <!--                    </CCol>-->
                                            <!--                  </CRow>-->

                                            <!--                  <br />-->
                                            <div
                                                    v-if="paymentCurrency && paymentCurrency.currency_code"
                                                    class="justify-content-end d-flex"
                                            >
                                                <CCol v-if="alertValue">
                                                    <!-- <CAlert v-if="alertValue" show color="danger"
                            >{{ alertValue }}
                          </CAlert>-->
                                                    <CAlert v-if="alertValue" show color="danger">
                                                        <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                                                            <p
                                                                    v-for="(value,index) in alertValue.valueList"
                                                                    :key="index"
                                                            >{{value}}</p>
                                                        </div>
                                                        <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                                                            <span>{{$t("cAlert.errorCode")+' : '}}</span>
                                                            <span
                                                                    v-for="(code,index) in alertValue.codeList"
                                                                    :key="index"
                                                            >{{code +' '}}</span>
                                                        </div>
                                                        <div v-if="alertValue&&alertValue.constructor==String">
                                                            <p>{{alertValue}}</p>
                                                        </div>
                                                    </CAlert>
                                                </CCol>
                                                <div
                                                        v-if="
                            paymentCurrency && paymentCurrency.currency_code
                          "
                                                        class="total_amount_payment"
                                                >
                                                    <label for>{{ $t("deposit.totalAmt") }}</label>

                                                    <strong
                                                            style="  padding-left: 5px;
      padding-right: 5px;"
                                                            v-if="
                              paymentCurrency && paymentCurrency.currency_code
                            "
                                                    >{{ paymentCurrency.currency_code.code }}</strong>

                                                    <div class="total-div-wrapper">
                                                        {{
                                                        getTotalDepsoitAmount(lsDepositCurrencies).toString()| formatNumber(
                                                          "USD"
                                                            )
                                                        }}
                                                    </div>
                                                </div>
                                                <!--                <br />-->
                                                <div class="total_amount_payment d-flex align-center align-item-center">
                                                    <label class="mb-0px">{{ $t("deposit.amntToPayment") }}</label>

                                                    <strong
                                                            class="d-flex align-center pr-25px"
                                                            style="  padding-left: 5px;
      padding-right: 5px;"
                                                            v-if="
                              paymentCurrency && paymentCurrency.currency_code
                            "
                                                    >{{ paymentCurrency.currency_code.code }}</strong>
                                                    <!-- :rules="
                              'required|onlynumber|validDecimal|valueGreaterZero|max_value:' +
                                $options.filters.currencyFormat(
                                  paymentDet.payableAmount,
                                  paymentCurrency.currency_code.code
                                )
                            " -->
                                                    <!-- max:'+getMaxCharacters(paymentDet.newAmount) -->
                                                    <!-- paymentDet.newAmount != null
                                ? paymentDet.newAmount
                                : $options.filters.currencyFormat(
                                    paymentDet.payableAmount,
                                    paymentCurrency.currency_code.code
                                  )  -->
                                                    <cTextInputComponent
                                                            class="input-edited inner-label-none"
                                                            :name="'amount'"
                                                            :isAmountField="true"
                                                            :value="getPayNewAmount(paymentDet.newAmount,paymentDet.payableAmount,paymentCurrency.currency_code.code)

                            "
                                                            :rules="
                              'required|noInitialSpace|onlynumber|validDecimal|no_zero|max:'+ getMaxCharacters(paymentDet.newAmount)+'|max_value:' +
                              
                            $options.filters.currencyFormat(       paymentDet.payableAmount,'USD')
                               
                                
                            "
                                                            @input="setDepositAmount"
                                                 
                                                    ></cTextInputComponent>
                                                </div>

                                                <CRow class="payment-details_pp_pay">
                                                    <div class="col-md-4 date-picker-custom-payment ml-auto">
                                                        <label for>{{ $t("deposit.receivedDate") }}</label>
                                                        <HotelDatePicker
                                                                :format='DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT'
                                                                :startDate="null"
                                                                :endDate="new Date()"
                                                                :singleDaySelection="true"
                                                                :minNights="0"
                                                                :i18n="assigni18nObjByLang()"
                                                                :startingDateValue="paymentDet.recievedDate"
                                                                :endingDateValue="new Date()"
                                                                :showYear="true"
                                                                :displayClearButton="false"
                                                                :hoveringTooltip="false"
                                                                @check-in-changed="setPaymentDate"
                                                        ></HotelDatePicker>
                                                    </div>
                                                    <div class="col-md-4 mr-auto text-field">
                                                        <!--                          <label for="">   {{ $t("deposit.paymentMethod") }}</label>-->
                                                        <cTextInputComponent
                                                                rules="required"
                                                                v-model="paymentDet.method"
                                                                :label="$t('deposit.pRef')"
                                                                :maxLength="100"
                                                                
                                                        ></cTextInputComponent>

                                                    </div>
                                                </CRow>

                                                <!-- <div class="paynow_btn d-flex">
                                                    <CButton
                                                            form="post-payment"
                                                            type="submit"
                                                             @click.prevent="handleSubmit(toggleConfirmModal)"
                                                            class="postpayment-paynow-btn"
                                                    >{{ $t("deposit.pay") }}
                                                    </CButton>
                                                </div> -->
                                            </div>

                                            <!--                  <CRow class="d-flex justify-content-end">-->

                                            <!--                  </CRow>-->
                                        </CCardFooter>
                                    </CForm>
                                </div>
                            <!-- </ValidationObserver> -->
                        </div>
                    </section>

                    <section v-else-if="lsPostpaidStatements && lsPostpaidStatements.length">
                        <!--        <CRow class="ai-center agent-name-wrap">-->
                        <!-- <CCol class="col-form-label col-xs-12 col-sm-12 col-md-12 label-none">
                          <multiselect
                            v-if="lsAllPostPaidAgents && lsAllPostPaidAgents.length"
                            v-model="agent"
                            :searchable="true"
                            :showLabels="false"
                            :label="'agencyName'"
                            :options="lsAllPostPaidAgents"
                            :track-by="'b2bid'"
                            :disabled="false"
                            :allow-empty="false"
                            :isMultiple="false"
                            :custom-label="agencyNameWithCode"
                            @input="onAgentChange"
                          >
                            <template slot="singleLabel" slot-scope="props">
                              <div class="d-flex cagent-selected">
                                <span class="">{{ props.option["agencyName"] }}</span>
                                <div class="right" v-if="props.option['b2bCode']">
                                  ({{ props.option["b2bCode"] }})
                                </div>
                              </div>
                            </template>

                            <template slot="option" slot-scope="props">
                              <div class="d-flex">
                                <strong class="w-50 txt-over-ellips">{{
                                  props.option["agencyName"]
                                }}</strong>
                                <span class="text-right ml-auto w-50 txt-over-ellips">{{
                                  props.option["b2bCode"]
                                }}</span>
                              </div>
                            </template>
                          </multiselect>
            </CCol>-->
                        <!--        </CRow>-->

                        <div
                                class
                                v-for="(agent, index) in lsPostpaidStatements.filter(
                agent => agent.agencyName != 'All'
              )"
                                :key="index + 'c'"
                        >
                            <div v-if="agent && agent.list && agent.list.length">
                                <div
                                        v-for="(statement, sindex) in agent.list"
                                        :key="sindex"

                                >
                                    <div class="card assign pricing-card"
                                         v-if="getStatementsCountForView(index,sindex)">
                                        <div class="card-head d-flex ai-center">
                                            <div class="align-left a-name agency-name">
                                                <h3>{{ agent.agencyName }}</h3>
                                                <span>{{ agent.b2bCode }}</span>
                                            </div>
                                            <div class="align-left a-name s-date">
                                                <p>{{$t('deposit.rpDate')}}</p>
                                                <span>
                        {{ statement.fromDate|formatDate }} {{$t('deposit.to')}}
                        {{ statement.toDate|formatDate }}
                      </span>
                                            </div>
                                            <div class="align-left a-name over-d-date" v-if="getOverDueDays(statement)">
<p>{{$t('deposit.paymentDueBy')}}</p>
                    <span>
                      {{ getOverDueDays(statement) }}

                    </span>
                                            </div>
                                            <!--                <div class="align-center  a-name">-->
                                            <!--                  <h5>-->
                                            <!--                    {{ formatDate(statement.fromDate) }} to-->
                                            <!--                    {{ formatDate(statement.toDate) }}-->
                                            <!--                  </h5>-->
                                            <!--                </div>-->
                                            <div class="align-right act-btn">
                                                <!-- &&getExtendDueDateBtn(statement) -->
                                                <button
                                                        v-if="!isViewOnly&&getExtendDueDateBtn(statement)"
                                                        @click="onExtendDueDate(agent, statement)"
                                                        data-v-c2da5fea
                                                        type="button"
                                                        color="info"
                                                        class="btn extendduedate-btn mob-w100"
                                                >{{ $t("deposit.extend") }}
                                                </button>
                                                <button
                                                        v-if="!isViewOnly"
                                                        @click="onPay(agent, statement)"
                                                        data-v-c2da5fea
                                                        type="button"
                                                        color="info"
                                                        class="btn extendduedate-btn mob-w100"
                                                        style="margin-left: 5px;"
                                                >{{ $t("deposit.payBtn") }}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="card-body pb-0px report_table_div-section">
                                            <table>
                                                <thead>
                                                <th>
                                                    <div>{{$t('deposit.status')}}</div>
                                                </th>
                                                <th
                                                        :key="titIndex"
                                                        v-for="(title, titIndex) in Object.keys(
                            getStatementTitles()
                          )"
                                                >{{ title == 'action' &&isViewOnly?null:$t(`statementTitle.${title}`) }}
                                                </th>
                                              
                                                </thead>
                                                <tbody
                                                        v-for="(stmntCurr, stIndex) in getStatementCurrencies(
                          statement
                        )"
                                                        :key="stIndex"
                                                >
                                                <tr>
                                                    <td class="color_indicator_sub">
                                                        <div
                                                                class="indi"
                                                                :class="{'paid':stmntCurr.statementStatus ==
                                    POSTPAID_STATEMENT_STATUS.PAID ||POSTPAID_STATEMENT_STATUS.EMPTY,'partial_paid':stmntCurr.statementStatus ==
                                    POSTPAID_STATEMENT_STATUS.PARTIALLY_PAID,'unpaid':stmntCurr.statementStatus ==
                                    POSTPAID_STATEMENT_STATUS.NEW}"
                                                        ></div>
                                                    </td>
                                                    <!-- <td
                            :key="titIndex"
                            v-for="(title, titIndex) in Object.keys(
                              getStatementTitles()
                            )"
                          >
                           <p :class="{'hyperlink-c':title=='dueDate'}">
                            <label v-if="title=='dueDate'">
                                {{stmntCurr[title]|formatDateTime}}
                            </label>

                          </p>
                          </td>-->
                                                    <td
                                                            :key="titIndex"
                                                            v-for="(title, titIndex) in Object.keys(
                              getStatementTitles()
                            )"
                                                    >
                                                        <!-- <p  v-if="title== 'dueDate'" :class="{'hyperlink-c':title=='dueDate'}">
                             <span>
                                {{ stmntCurr[title]|formatDate}}
                              </span>

                            </p>-->

                                                        <p
                                                                v-if="title != 'action'"
                                                                :class="{'hyperlink-c':title=='dueDate'||(title=='invoice'&&stmntCurr[title]!=0)||(( title == 'paidAmount'||title=='dueAmount') &&stmntCurr.statementStatus !=
                                  POSTPAID_STATEMENT_STATUS.NEW &&  stmntCurr.statementStatus !=
                                  POSTPAID_STATEMENT_STATUS.EMPTY)}"
                                                        >
                                                            <label
                                                                    @click="onClickHyperLink(title,stmntCurr,agent)"
                                                                    v-if="
                                  title == 'dueAmount' ||
                                    title == 'paidAmount' ||
                                    title == 'balanceDue'|| title=='invoice'
                                "
                                                            >
                                                                {{
                                                                title=='invoice'?stmntCurr[title]:(stmntCurr[title])
                                                                }}
                                                            </label>
                                                            <label @click="onClickHyperLink(title,stmntCurr,agent)"
                                                                   v-else
                                                                   :class="{'overdue-class':title=='dueDate'&&getOverDueClass(stmntCurr[title],stmntCurr)}"
                                                                   :style="{color:title=='dueDate'&&getOverDueClass(stmntCurr[title],stmntCurr)?'red':''}"
                                                            >
                                                                {{
                                                                title == "dueDate"?stmntCurr[title]?
                                                                $options.filters.formatDate( stmntCurr[title]):''
                                                                : stmntCurr[title]
                                                                }}
                                                            </label>
                                                        </p>
                                                        <!-- <CButton
                              v-else-if="isViewOnly"
                              :disabled="lsPrintableStatements.length > 0"
                              @click="
                                selectPrintStatements(stmntCurr.statementNo)
                              "
                              class="btn btn filter-btn-cus success"
                            >
                              {{ $t("deposit.print") }}
                            </CButton>-->

                                                        <CBadge
                                                                v-else-if=" !isViewOnly &&
                                statement[stmntCurr.name].statementStatus ==
                                  POSTPAID_STATEMENT_STATUS.PAID
                              "
                                                                color="success"
                                                        >{{ $t("deposit.paid") }}
                                                        </CBadge>
                                                        <CButton
                                                                @click="
                                payStatementFromAll(
                                  agent,
                                  stmntCurr.statementNo,stmntCurr
                                )
                              "
                                                                class="btn filter-btn-cus success"
                                                                v-else-if=" !isViewOnly &&
                                statement[stmntCurr.name].statementStatus !=
                                  POSTPAID_STATEMENT_STATUS.EMPTY
                              "
                                                        >{{ $t("deposit.pay") }}
                                                        </CButton>
                                                    </td>
                                                
                                                </tr>
                                                </tbody>
                                            </table>
                                            <!--                <CRow class="theader">-->
                                            <!--                  <CCol>-->
                                            <!--<h5>Status</h5>-->
                                            <!--                  </CCol>-->
                                            <!--                  <CCol-->
                                            <!--                    :key="titIndex"-->
                                            <!--                    v-for="(title, titIndex) in Object.keys(-->
                                            <!--                      getStatementTitles()-->
                                            <!--                    )"-->
                                            <!--                  >-->
                                            <!--                    <h5 style="white-space: nowrap">-->
                                            <!--                      {{ $t(`statementTitle.${title}`) }}-->
                                            <!--                    </h5>-->

                                            <!--                    <br />-->
                                            <!--                  </CCol>-->
                                            <!--                </CRow>-->

                                            <!--                <CRow class="tbody"-->
                                            <!--                  v-for="(stmntCurr, stIndex) in getStatementCurrencies(-->
                                            <!--                    statement-->
                                            <!--                  )"-->
                                            <!--                  :key="stIndex"-->
                                            <!--                >-->
                                            <!--                <CCol class="color_indicator_sub">-->
                                            <!--                  <div class="indi paid"></div>-->

                                            <!--                  <input v-if="isViewOnly" type="checkbox" :checked="-->
                                            <!--                      lsPrintableStatements.includes(stmntCurr.statementNo)-->
                                            <!--                    "-->
                                            <!--                    @input="selectPrintStatements(stmntCurr.statementNo)" />-->
                                            <!--                   </CCol>-->
                                            <!--                  <CCol-->
                                            <!--                    :key="titIndex"-->
                                            <!--                    v-for="(title, titIndex) in Object.keys(-->
                                            <!--                      getStatementTitles()-->
                                            <!--                    )"-->
                                            <!--                  >-->
                                            <!--                    <p v-if="title != 'action'">-->
                                            <!--                      <label-->
                                            <!--                        @click="-->
                                            <!--                          title == 'paidAmount' &&-->
                                            <!--                          stmntCurr.statementStatus !=-->
                                            <!--                            POSTPAID_STATEMENT_STATUS.NEW-->
                                            <!--                            ? getPaymentHistory(-->
                                            <!--                                stmntCurr.statementNo,-->
                                            <!--                                agent.b2bid-->
                                            <!--                              )-->
                                            <!--                            : null-->
                                            <!--                        "-->
                                            <!--                        v-if="-->
                                            <!--                          title == 'dueAmount' ||-->
                                            <!--                            title == 'paidAmount' ||-->
                                            <!--                            title == 'balanceDue'-->
                                            <!--                        "-->
                                            <!--                      >-->
                                            <!--                        {{-->
                                            <!--                          $options.filters.formatNumber(-->
                                            <!--                            stmntCurr[title],-->
                                            <!--                            stmntCurr.name-->
                                            <!--                          )-->
                                            <!--                        }}-->
                                            <!--                      </label>-->
                                            <!--                      <span v-else>-->
                                            <!--                        {{-->
                                            <!--                          title == "dueDate"-->
                                            <!--                            ? formatDate(stmntCurr[title])-->
                                            <!--                            : stmntCurr[title]-->
                                            <!--                        }}-->
                                            <!--                      </span>-->
                                            <!--                    </p>-->
                                            <!--                    <CButton v-else-if="isViewOnly"     :disabled="-->
                                            <!--                      lsPrintableStatements.length>0" @click="selectPrintStatements(stmntCurr.statementNo)">-->
                                            <!--                      {{ $t("deposit.print") }}-->
                                            <!--                    </CButton>-->

                                            <!--                    <CBadge-->
                                            <!--                      v-else-if="-->
                                            <!--                        statement[stmntCurr.name].statementStatus ==-->
                                            <!--                          POSTPAID_STATEMENT_STATUS.PAID-->
                                            <!--                      "-->
                                            <!--                      color="success"-->
                                            <!--                    >-->
                                            <!--                      {{ $t("deposit.paid") }}-->
                                            <!--                    </CBadge>-->
                                            <!--                    <CButton-->
                                            <!--                      @click="payStatementFromAll(agent, stmntCurr.statementNo)" class="btn filter-btn-cus success"-->
                                            <!--                      v-else-if="-->
                                            <!--                        statement[stmntCurr.name].statementStatus !=-->
                                            <!--                          POSTPAID_STATEMENT_STATUS.EMPTY-->
                                            <!--                      "-->
                                            <!--                    >-->
                                            <!--                      {{ $t("deposit.pay") }}-->
                                            <!--                    </CButton>-->
                                            <!--                    <br />-->
                                            <!--                    <br />-->
                                            <!--                  </CCol>-->
                                            <!--                </CRow>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <!--
                    <section v-else class="d-flex justify-content-center ">
                        <strong>
                            {{ $t("deposit.noResult") }}
                        </strong>
                    </section>
                </div>
            </CCardBody>
        </CCard>

        <cAlertModal
                v-if="showConfirmModal"
                :buttonList="getModalButtons()"
                :status="2"
                :infoTitle="''"
                :show="showConfirmModal"
                :desc="getModalDesc()"
          ></cAlertModal>-->

                    <section v-else class="no-result-section ">
                        <strong>{{ $t("deposit.noResult") }}</strong>
                    </section>

                </div>
            </CCardBody>
            <CCardFooter class="d-flex justify-content-between">
                <CButton v-if="isSingleAgent||selStatement" @click="navToAllAgentSelection"


                         class=" filter-btn-cus bg-danger mr-auto d-flex align-center"
                ><span>
                    {{ $t("deposit.goBack") }}
                </span>
                </CButton>
                <div class="paynow_btn d-flex" v-if="lsPaymentStatements && lsPaymentStatements.length">
                                                    <CButton
                                                            form="post-payment"
                                                            type="submit"
                                                             @click.prevent="handleSubmit(toggleConfirmModal)"
                                                            class="postpayment-paynow-btn"
                                                    >{{ $t("deposit.pay") }}
                                                    </CButton>
                                                </div>
<!--                <CButton v-if="lsPaymentStatements && lsPaymentStatements.length"-->
<!--                        form="post-payment"-->
<!--                        type="submit"-->
<!--                        class="postpayment-paynow-btn"-->
<!--                >{{ $t("deposit.pay") }}-->
<!--                </CButton>-->
            </CCardFooter>


        </CCard>
</ValidationObserver>
        <cAlertModal
                v-if="isDepositSuccess && agent && paymentCurrency"
                :buttonList="[{name:$t('deposit.ok'),func:onDepositSuccess ,color:'success'}]"
                :status="1"
                 
                :show="isDepositSuccess"
                :desc="$t('deposit.depositSuccModal',{curr: paymentCurrency.currency_code.code,
                            amount: ( paymentDet.newAmount?paymentDet.newAmount:paymentDet.payableAmount),
                               
                            
                            agencyName: agent.agencyName,
                            agtCode: agent.b2bCode})"
        ></cAlertModal>
        <cAlertModal
                v-if="isDepositFailed"
                :buttonList="[{name:$t('deposit.ok'),func:toggleConfirmModal,color:'danger'}]"
                :status="0"
                  :key='0'
                :show="isDepositFailed"
                :desc="alertValue"
        ></cAlertModal>

        <cAlertModal
                v-if="showConfirmModal"
                :buttonList="getModalButtons()"
                :status="2"
                :key="2"
                :infoTitle="''"
                :show="showConfirmModal"
                :desc="getModalDesc()"
        ></cAlertModal>
         <cAlertModal
                v-if="isDateExtended"
                :buttonList="[{name:$t('deposit.ok'),func:toggleConfirmModal,color:'success'}]"
                :status="1"
                    :key="1"
                :show="isDateExtended"
                :desc="$t('deposit.extendDateSuccDesc')"
        ></cAlertModal>


        <div class="ph_table_popup_wrap history">
            <CModal
                    v-if="showDueDateHisModal&&lsDueDateHistory"
                    :show.sync="showDueDateHisModal"
                    :centered="true"
                    size="lg"
                    :title="$t('deposit.extendDueDateHis')"
            >
                <template>
                    <div class="ph_table_popup ">
                        <img src="@imgPath/img/svg/icons/excle-icon.svg" alt="" @click="toggleDueDateExcelModal()"
                             class="export-icon-btn " v-if="lsDueDateHistory.length!=0">

                        <div class="ticketing_queue">
                            <div id="user-manage-table" class="table-striped">
                                <table>
                                    <thead>
                                    <tr>
                                        <th class="position-relative pr-4">{{ $t("deposit.number") }}</th>

                                        <th class="position-relative pr-4">{{ $t("deposit.timestamp") }}</th>
                                        <th class="position-relative pr-4">{{ $t("deposit.changedBy") }}</th>

                                        <th class="position-relative pr-4">{{ $t("deposit.oldDate") }}</th>
                                        <th class="position-relative pr-4">{{ $t("deposit.newDate") }}</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(dueDateObj, index) in lsDueDateHistory" :key="index + 'o'">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ dueDateObj.ts|formatDateTime(defaultDateTimeFormat) }}</td>
                                        <td>{{ dueDateObj.update_by }}</td>

                                        <td>{{ dueDateObj.old_date|formatDate }}</td>
                                        <td>{{ dueDateObj.new_date|formatDate }}</td>


                                    </tr>


                                    </tbody>

                                </table>
                                <div v-if="lsDueDateHistory.length==0" class="no-result-table">{{ $t("deposit.noHisFound") }}</div>
                            </div>
                        </div>
                    </div>


                </template>

                <template #footer-wrapper>
                    <div></div>
                </template>
            </CModal>
        </div>

        <div class="ph_table_popup_wrap invoice">
            <CModal
                    v-if="showInvoiceModal&&lsInvoices"
                    :show.sync="showInvoiceModal"
                    :centered="true"
                    size="lg"
                    :title="$t('deposit.invoices')"
            >
                <template>
                    <div class="ph_table_popup ">
                        <img src="@imgPath/img/svg/icons/excle-icon.svg" alt="" @click="toggleInvoicesExcelModal()"
                             class="export-icon-btn " v-if="lsInvoices.length != 0">

                        <div class="ticketing_queue">
                            <div id="user-manage-table" class="table-striped">
                                <table>
                                    <thead>
                                    <tr>
                                        <th class="position-relative pr-4">{{ $t("deposit.number") }}</th>
                                        <th class="position-relative pr-4">{{ $t("deposit.orderId") }}</th>
                                        <th class="position-relative pr-4">{{ $t("deposit.route") }}</th>
                                        <th class="position-relative pr-4">{{ $t("deposit.journeyType") }}</th>
                                        <th class="position-relative pr-4">{{ $t("deposit.numOfPax") }}</th>

                                        <th class="position-relative pr-4">{{ $t("deposit.passengerName") }}</th>
                                        <!-- <th class="position-relative pr-4">{{ $t("deposit.transactiondate") }}</th> -->
                                        <th class="position-relative pr-4">{{ $t("deposit.transactionType") }}</th>
                                        <th class="position-relative pr-4">{{ $t("deposit.currency") }}</th>
                                        <th class="position-relative pr-4">{{ $t("deposit.amount") }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(invoiceObj, index) in lsInvoices" :key="index + 'o'">
                                        <td>{{ index + 1 }}</td>
                                        <!-- <td>{{ invoiceObj.transactionid }}</td> -->
                                        <td>{{invoiceObj.orderid?invoiceObj.orderid:'-'}}</td>

                                        <td>
                                            <div v-if="invoiceObj.route">
            <div class="text-c" v-for="(route,index) in invoiceObj.route" :key="index">
                                                {{ route }}
                                            </div>
                                             </div>
                                            <div v-else>
                                                -
                
                                            </div>
                                                    

                                        </td>
                                        <td >{{ invoiceObj.journeytype?getTripCategory(invoiceObj.journeytype):"-"}}</td>
                                        <td>{{ invoiceObj.paxcount?invoiceObj.paxcount:'-' }}</td>

                                        <td>{{invoiceObj.paxname?invoiceObj.paxname:'-' }}</td>

                                        <td>{{invoiceObj.transactiontype?getTransactionType(invoiceObj.transactiontype):'-' }}</td>
                                        <td>{{invoiceObj.currencycode? invoiceObj.currencycode:'-' }}</td>
                                        <td>{{ invoiceObj.amount.toString() }}
                                        </td>
                                    </tr>
                                    <tr v-if="lsInvoices.length==0">
                                        {{ $t("deposit.noInvoicesFound") }}
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <!--        <CRow>-->
                    <!--          <CCol>-->
                    <!--            <h4>-->
                    <!--              {{ $t("deposit.number") }}-->
                    <!--            </h4>-->
                    <!--          </CCol>-->

                    <!--          <CCol>-->
                    <!--            <h4>-->
                    <!--              {{ $t("deposit.paidAmount") }}-->
                    <!--            </h4>-->
                    <!--          </CCol>-->
                    <!--          <CCol>-->
                    <!--            <h4>-->
                    <!--              {{ $t("deposit.receivedDate") }}-->
                    <!--            </h4>-->
                    <!--          </CCol>-->
                    <!--          <CCol>-->
                    <!--            <h4>-->
                    <!--              {{ $t("deposit.pRef") }}-->
                    <!--            </h4>-->
                    <!--          </CCol>-->

                    <!--            <CCol>-->
                    <!--            <h4>-->
                    <!--              {{ $t("deposit.paymentBy") }}-->
                    <!--            </h4>-->
                    <!--          </CCol>-->
                    <!--        </CRow>-->
                    <!--        <br />-->

                    <!--        <CRow v-for="(paymentHis, index) in lsPaymentHis" :key="index + 'o'">-->
                    <!--          <CCol>-->
                    <!--            <label>-->
                    <!--              {{ index + 1 }}-->
                    <!--            </label>-->
                    <!--          </CCol>-->
                    <!--          <CCol>-->
                    <!--            <label>-->
                    <!--              {{ paymentHis.paidamount }}-->
                    <!--            </label>-->
                    <!--          </CCol>-->
                    <!--          <CCol>-->
                    <!--            <label>-->
                    <!--              {{ formatDate(paymentHis.date) }}-->
                    <!--            </label>-->
                    <!--          </CCol>-->
                    <!--          <CCol>-->
                    <!--            <label>-->
                    <!--              {{ paymentHis.method }}-->
                    <!--            </label>-->
                    <!--          </CCol>-->

                    <!--            <CCol>-->
                    <!--            <label>-->
                    <!--              {{ paymentHis.username }}-->
                    <!--            </label>-->
                    <!--          </CCol>-->
                    <!--        </CRow>-->
                </template>

                <template #footer-wrapper>
                    <div></div>
                </template>
            </CModal>
        </div>
        <div class="ph_table_popup_wrap">
            <CModal
                    v-if="showPaymentHisModal"
                    :show.sync="showPaymentHisModal"
                    :centered="true"
                    size="lg"
                    :title="getTitleForModal()"
            >
                <template>
                    <div class="ph_table_popup">
                        <img
                                src="@imgPath/img/svg/icons/excle-icon.svg"
                                alt
                                @click="togglePayHisExcelModal()"
                                class="export-icon-btn"
                                v-if="lsPaymentHis.length != 0"
                        />

                        <div class="ticketing_queue">
                            <div id="user-manage-table" class="table-striped">
                                <div v-if="isTotalDueAmtPopUp">
                                    <table>
                                        <thead>
                                        <tr>
                                            <th class="position-relative pr-4">{{ $t("deposit.number") }}</th>
                                            <th class="position-relative pr-4">{{ $t("deposit.receivedDate") }}</th>
                                            <th class="position-relative pr-4">{{ $t("deposit.pRef") }}</th>

                                            <th class="position-relative pr-4">{{ $t("deposit.currency") }}</th>
                                            <th class="position-relative pr-4">{{ $t("deposit.paidAmount") }}</th>
                                            <th class="position-relative pr-4">{{ $t("deposit.dueAmt") }}</th>

                                            <th class="position-relative pr-4">{{ $t("deposit.paymentBy") }}</th>
                                            <!-- <th class="position-relative pr-4">{{ $t("deposit.number") }}</th> -->
                                            <!-- <th class="position-relative pr-4">{{ $t("deposit.amount") }}</th>

       <th class="position-relative pr-4">{{ $t("deposit.currency") }}</th>
       <th class="position-relative pr-4">{{ $t("deposit.time") }}</th>
       <th class="position-relative pr-4">{{ $t("deposit.paymentBy") }}</th> -->
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(paymentHis, index) in lsPaymentHis" :key="index + 'o'">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ paymentHis.date|formatDateTime(defaultDateTimeFormat) }}</td>
                                            <td>{{ paymentHis.method?paymentHis.method:'-' }}</td>
                                            <td>{{ paymentHis.currency?paymentHis.currency:'-' }}</td>

                                            <td>{{ paymentHis.paidamount?paymentHis.paidamount:'-'}}</td>
                                            <td>{{ paymentHis.pendingamount?paymentHis.pendingamount:'-' }}</td>

                                            <td>{{ paymentHis.username?paymentHis.username:'-' }}</td>

                                        </tr>

                                        </tbody>
                                        <div v-if="lsPaymentHis.length==0" class="no-result-table">
                                           {{ $t("deposit.noHisFound") }}
                                        </div>
                                    </table>
                                </div>

                                <div v-else>
                                    <table>
                                        <thead>
                                        <tr>
                                            <th class="position-relative pr-4">{{ $t("deposit.number") }}</th>
                                            <th class="position-relative pr-4">{{ $t("deposit.receivedDate") }}</th>
                                            <th class="position-relative pr-4">{{ $t("deposit.pRef") }}</th>

                                            <th class="position-relative pr-4">{{ $t("deposit.currency") }}</th>
                                            <th class="position-relative pr-4">{{ $t("deposit.paidAmount") }}</th>
                                            <th class="position-relative pr-4">{{ $t("deposit.paymentBy") }}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(paymentHis, index) in lsPaymentHis" :key="index + 'o'">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ paymentHis.date|formatDateTime(defaultDateTimeFormat) }}</td>
                                            <td>{{ paymentHis.method?paymentHis.method:'-' }}</td>
                                            <td>{{ paymentHis.currency?paymentHis.currency:'-' }}</td>

                                            <td>{{ paymentHis.paidamount.toString()
                                                }}
                                            </td>

                                            <td>{{ paymentHis.username?paymentHis.username:'-' }}</td>
                                        </tr>

                                        </tbody>
                                    </table>
                                  <div v-if="lsPaymentHis.length==0" class="no-result-table">
                                      {{ $t("deposit.noHisFound") }}
                                  </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!--        <CRow>-->
                    <!--          <CCol>-->
                    <!--            <h4>-->
                    <!--              {{ $t("deposit.number") }}-->
                    <!--            </h4>-->
                    <!--          </CCol>-->

                    <!--          <CCol>-->
                    <!--            <h4>-->
                    <!--              {{ $t("deposit.paidAmount") }}-->
                    <!--            </h4>-->
                    <!--          </CCol>-->
                    <!--          <CCol>-->
                    <!--            <h4>-->
                    <!--              {{ $t("deposit.receivedDate") }}-->
                    <!--            </h4>-->
                    <!--          </CCol>-->
                    <!--          <CCol>-->
                    <!--            <h4>-->
                    <!--              {{ $t("deposit.pRef") }}-->
                    <!--            </h4>-->
                    <!--          </CCol>-->

                    <!--            <CCol>-->
                    <!--            <h4>-->
                    <!--              {{ $t("deposit.paymentBy") }}-->
                    <!--            </h4>-->
                    <!--          </CCol>-->
                    <!--        </CRow>-->
                    <!--        <br />-->

                    <!--        <CRow v-for="(paymentHis, index) in lsPaymentHis" :key="index + 'o'">-->
                    <!--          <CCol>-->
                    <!--            <label>-->
                    <!--              {{ index + 1 }}-->
                    <!--            </label>-->
                    <!--          </CCol>-->
                    <!--          <CCol>-->
                    <!--            <label>-->
                    <!--              {{ paymentHis.paidamount }}-->
                    <!--            </label>-->
                    <!--          </CCol>-->
                    <!--          <CCol>-->
                    <!--            <label>-->
                    <!--              {{ formatDate(paymentHis.date) }}-->
                    <!--            </label>-->
                    <!--          </CCol>-->
                    <!--          <CCol>-->
                    <!--            <label>-->
                    <!--              {{ paymentHis.method }}-->
                    <!--            </label>-->
                    <!--          </CCol>-->

                    <!--            <CCol>-->
                    <!--            <label>-->
                    <!--              {{ paymentHis.username }}-->
                    <!--            </label>-->
                    <!--          </CCol>-->
                    <!--        </CRow>-->
                </template>

                <template #footer-wrapper>
                    <div></div>
                </template>
            </CModal>
        </div>

        <CModal
                v-if="showPaymentTransModal"
                :show.sync="showPaymentTransModal"
                :centered="true"
                size="lg"
                :title="$t('deposit.paymentTras')"
        >
            <template>
                <img
                        src="@imgPath/img/svg/icons/excle-icon.svg"
                        alt
                        @click="togglePayHisExcelModal()"
                        class="export-icon-btn"
                />
                <CRow>
                    <CCol>
                        <h4>{{ $t("deposit.number") }}</h4>
                    </CCol>

                    <CCol>
                        <h4>{{ $t("deposit.invoice") }}</h4>
                    </CCol>
                    <CCol>
                        <h4>{{ $t("deposit.receivedDate") }}</h4>
                    </CCol>
                    <CCol>
                        <h4>{{ $t("deposit.paymentMethod") }}</h4>
                    </CCol>
                </CRow>
                <br/>

                <CRow v-for="(paymentHis, index) in lsPaymentTransactions" :key="index + 'ot'"></CRow>
            </template>

            <template #footer-wrapper>
                <div></div>
            </template>
        </CModal>
        <cJsonExcelModal
                v-if="showJsonExcelModal "
                :show="showJsonExcelModal"
                :desc="$t('jsonExcelModal.desc', { name: $t('deposit.statement') })"
                :onCancel="toggleJsonExcelModal"
        >
            <template #jsonExcel>
                <div @click="toggleJsonExcelModal()">
                    <cExportExcel
                            :title="getExcelTitle()"
                            :data="getPrintStatements()"
                            :fields="getJsonExcelFields()"
                            worksheet="Statements"
                            :name='getExcelFileName($t("deposit.statementsFileName"))'
                    >{{ $t("deposit.download") }}
                    </cExportExcel>
                </div>
            </template>
        </cJsonExcelModal>

        <cJsonExcelModal
                v-if="showPayHisJsonExcelModal "
                :show="showPayHisJsonExcelModal"
                :desc="$t('jsonExcelModal.desc', { name:isTotalDueAmtPopUp?$t('deposit.transactionStatement'):$t('deposit.paymentHis') })"
                :onCancel="togglePayHisExcelModal"
        >
            <template #jsonExcel>
                <div @click="togglePayHisExcelModal()">
                    <!-- :title="getExcelTitle()" -->
                    <cExportExcel
                            :title="getExcelTitle()"
                            :data="getPrintPayHis()"
                            :fields="getExcelFieldsForPayHis()"
                            worksheet="Statements"
                            :name="getFileName()"
                    >{{ $t("deposit.download") }}
                    </cExportExcel>
                </div>
            </template>
        </cJsonExcelModal>

        <cJsonExcelModal
                v-if="showInvoiceJsonExcelModal"
                :show="showInvoiceJsonExcelModal"
                :desc="$t('jsonExcelModal.desc', { name: $t('deposit.invoices') })"
                :onCancel="toggleInvoicesExcelModal"
        >
            <template #jsonExcel>
                <div @click="toggleInvoicesExcelModal()">
                    <!-- :title="getExcelTitle()" -->
                    <cExportExcel
                            :title="getExcelTitle()"
                            :data="getPrintInvoices()"
                            :fields="getExcelFieldsForInvoices()"
                            worksheet="Statements"
                            :name='getExcelFileName($t("deposit.invoiceFileName"))'
                    >{{ $t("deposit.download") }}
                    </cExportExcel>
                </div>
            </template>
        </cJsonExcelModal>


        <cJsonExcelModal
                v-if="showDueDateJsonExcelModal"
                :show="showDueDateJsonExcelModal"
                :desc="$t('jsonExcelModal.desc', { name: $t('deposit.extendDueDateHis') })"
                :onCancel="toggleDueDateExcelModal"
        >
            <template #jsonExcel>
                <div @click="toggleDueDateExcelModal()">
                    <!-- :title="getExcelTitle()" -->
                    <cExportExcel
                            :title="getExcelTitle()"
                            :data="getPrintDueDateHis()"
                            :fields="getExcelFieldsForDueDateHis()"
                            worksheet="Statements"
                            :name='getExcelFileName($t("deposit.extendDueFileName"))'
                    >{{ $t("deposit.download") }}
                    </cExportExcel>
                </div>
            </template>
        </cJsonExcelModal>


    </div>
</template>

<script>
    import router, {navigate, goBack, updateDataEdited} from "./../../router/index";
    import {addDays, formatDate, formatDateTime, getDiffBtwDates} from "./../../util/date/dateFunctions";
    import {mapGetters, mapActions} from "vuex";
    import {
        PATHNAME,
        COMPONENT_NAME,
        SECTOR_TYPE,
        PRICING_VALUE,
        DEFAULT_DROPDOWN_STATUS,
        POSTPAID_STATEMENT_STATUS,
        APPROVEAGENT,DATE_TIME_FORMAT,
        POSTPAID_TYPE, ORDER, TRANSACTION_TYPE,ALL_CLIENT_CODE
    } from "./../../util/constants";
    import apiGetPostPaidStatementList from "./../../services/apiGetPostPaidStatementList";
    import apiExchangeRateDetails from "./../../services/apiExchangeRateDetails";
    import apiPostPaidExtendDueDate from "./../../services/apiPostPaidExtendDueDate";
    import apiPostPaidDeposit from "./../../services/apiPostPaidDeposit";
    import apiPostPaidTransactions from "./../../services/apiPostPaidTransactions";
    import apiGetInvoiceDetail from "./../../services/apiGetInvoiceDetail";
    import apiGetExtendDueDateHistory from "../../services/apiGetExtendDueDateHistory";

    import apiPostPaidPaymentHistory from "../../services/apiPostPaidPaymentHistory";
    import Logger from "./../../services/logger";
    //import flightDatePicker from "vue-flight-datepicker";
    import HotelDatePicker from "vue-range-datechooser";
    import cSector from "../../components/pricing/cSector";
    import cOrgCurrencyDp from "./../../components/currency/cOrgCurrencyDp";
    import cTextInputComponent from "../../components/form/cTextInputComponent";
    import cAlertModal from "../../components/form/cAlertModal";
    import cAirLine from "../../components/pricing/cAirLine";
    import cAgent from '../../components/form/cAgent'
    import SERVICE_URL, {
        FILE_NAME,
        LOG_TYPE,
        HTTP_CODES
    } from "./../../config/API_DATA";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "../../util/apiValidate";
    import {
        handleJWT,
        getErrorAlertValue,
        cloneData,
        addClassToBody,
        removeClassBody,
        OrderByList,OrderBy,
        cloneDeep, getMaxCharOfAmount
    } from "../../util/util";

    import {subDays, subMonths, addMonths} from "../../util/date/dateFunctions";

    import BaseConfiguration from "../../config/base";
    import {ValidationProvider, ValidationObserver, localize} from "vee-validate";

    import cRadioButton from "../../components/form/cRadioButton";
    import multiselect from "vue-multiselect";
    import cCurrencyBoxes from "../../components/currency/cCurrencyBoxes";
    // import nb from "../../translations/validation/nb.json";
    // import en from "../../translations/validation/en.json";
    import cExportExcel from "../../components/excel/cExportExcel";
    import cJsonExcelModal from "./../modal/cJsonExcelModal";
    import cPaginationLenOption from "../../components/dataTable/cPaginationLenOption";
     import Vue from "vue";
    import datePickerInput from "../../components/datePicker/datePickerInput";
import {VMdDateRangePicker} from "material-vue-date-picker";

    // localize({
    //     en: {
    //         messages: en.messages
    //     },
    //     nb: {
    //         messages: nb.messages
    //     }
    // });
    export default {
        name: COMPONENT_NAME.DEPOSIT,

        components: {
            multiselect,
            HotelDatePicker,
            cTextInputComponent,
            cOrgCurrencyDp,
            cAlertModal,
            cAgent,
            ValidationObserver,
            cExportExcel,
            cJsonExcelModal,
            cPaginationLenOption,
            datePickerInput,
            VMdDateRangePicker
        },

        props: {
            isViewOnly: {
                type: Boolean,
                default: false
            }
        },
        data: () => {
            return {
                defaultDateTimeFormat: BaseConfiguration.defaultDateTimeFormat,
                hyperLinkSelStatement: null,
                isDepositFailed: false,
                isDepositSuccess: false,
                selStatement: null,
                cSystemDepositWatchList: {
                    filteredlistCount: null,
                    itemsPerPage: 25,
                    currentPageNum: 1,
                    lsItemsPerPage: [5, 10, 15, 25]
                },
                // pageNum:1,
                POSTPAID_STATEMENT_STATUS: POSTPAID_STATEMENT_STATUS,
                alertValue: null,
                showJsonExcelModal: false,
                showConfirmModal: false,
                lsPrintableStatements: [],
                postpaidStmntRes: [],
                lsPostpaidStatements: [],
                showExtendDueDateModal: false,
                isAscSort: true,

                stmntExtendDet: {
                    lsStmnts: [],
                    lsStmntsCurrencies: [],
                    currDueDate: null,
                    newDueDate: null,
                    canExtendDays: null
                },

                lsSystemExchangeRate: [],
                paymentCurrency: null,
                lsPaymentStatements: [],
                isSingleAgent: false,
                lsPostpaidTypes: [],
                agent: null,

                allAgent: {
                    type: APPROVEAGENT.POSTPAID,
                    details: null
                },

                lsAllPostPaidAgents: [],
                lsDepositCurrencies: [],
                postpaid: {
                    type: null,
                    isPaid: false,
                    isDueBalance: false,
                    isPastDueDate: false
                },

                paymentDet: {
                    isAll: false,
                    payableAmount: 0,
                    recievedDate: new Date(),
                    method: null,
                    newAmount: null
                },
                lsPaymentHis: [],
                showPaymentHisModal: false,

                postpaidStatement: {
                    fromDate: null,
                    toDate: null,
                    status: [],
                    b2bId: null
                },

                lsPaymentTransactions: [],
                showPaymentTransModal: false,
                selAgentObj: null,
                showPayHisJsonExcelModal: false,
                selHisAgent: null,
                lsInvoices: null,
                showInvoiceModal: false,
                showInvoiceJsonExcelModal: false,
                lsStatementNo: [],
                agentListByStatementNo: null,
                showPostPaidJsonExcelModal: false,
                postPaidCount: null,
                isTotalDueAmtPopUp: false,
                lsDueDateHistory: null,
                showDueDateHisModal: false,
                showDueDateJsonExcelModal: false,
                 isShowStatementDp:true,
                 isDateExtended:false,
                 selCurrencyCode:null,
                 isOrgCurrencyDpShow:true
                //   clientCode:BaseConfiguration.clientCode,
                // allClientCode:ALL_CLIENT_CODE,
            };
        },
        watch: {



            lsPostpaidStatements: {
                immediate: false,
                deep: true,
                handler: function (newVal, oldVal) {

                    // this.cSystemDepositWatchList.filteredlistCount=this.lsPostpaidStatements.length;
                    let count = 0;
                    for (let i = 0; i < this.lsPostpaidStatements.length; i++) {
                        count = count + this.lsPostpaidStatements[i].list.length;
                    }
                    this.cSystemDepositWatchList.filteredlistCount = count;

                }
            },

            agent: {
                immediate: false,
                deep: true,
                handler: function (newVal, oldVal) {

                    // this.cSystemDepositWatchList.filteredlistCount=this.lsPostpaidStatements.length;
                    // let count=0;
                    // for(let i=0;i<this.lsPostpaidStatements.length;i++){
                    //  count= count+this.lsPostpaidStatements[i].list.length;
                    // }
                    if (this.isSingleAgent && this.agent && this.agent.list) {
                        this.cSystemDepositWatchList.filteredlistCount = this.agent.list.length;

                    }

                }
            },
        },

        computed: {

     DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
            ...mapGetters("sDashBoard", {
                agentDetail: "GET_AGENT_LOGO_DET_RES"
            }),
            ...mapGetters("sCSystemDeposit", {
                GET_OVER_DUE_FILTER: "GET_OVER_DUE_FILTER"
            }),
             ...mapGetters("sCurrencyLs", {
      GET_ORG_CURRENCY_RES: "GET_ORG_CURRENCY_RES"
    }),
        },

        methods: {
            ...mapActions("sCSystemDeposit", {
                SET_OVER_DUE_FILTER: "SET_OVER_DUE_FILTER"
            }),
                     scrollToElement(pRef) {
                var el = null;
                if(pRef == this.$t('deposit.amntToPayment')) { 
                     el = this.$refs[this.$t('deposit.amntToPayment')];
                }
                if(pRef == 'AmounttopayData'){
                    el = this.$refs.AmounttopayData;
                }
                if (el) {
                     if(el[0]){
                        el[0].$el.scrollIntoView({ behavior: "smooth" });
                    }else{
                        el.$el.scrollIntoView({ behavior: "smooth" });
                    }
                    
                   
                }
  },

            toggleDatePicker() {
                try {
                  if(BaseConfiguration.isDebug) console.log("toggleDatePicker");
              if(this.$refs&&this.$refs.datePicker&&this.$refs.datePicker.pickerVisible){
                 this.$refs.datePicker.togglePicker();
              }
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_SYSTEM_DEPOSIT,
                          "error in toggleDatePicker",
                          err.toString(),
                          "toggleDatePicker",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  
                }, 

            hideAllModals() {
                try {
                  if(BaseConfiguration.isDebug) console.log("hideAllModals");
                  this.isDepositFailed=false;
                  this.isDepositSuccess=false;
                  this.showConfirmModal=false;
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_SYSTEM_DEPOSIT,
                          "error in hideAllModals",
                          err.toString(),
                          "hideAllModals",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
               
                }, 










            onNewDueAmount() {
                try {
                  if(BaseConfiguration.isDebug) console.log("onNewDueAmount");
                   this.lsDepositCurrencies =this. getDepositCurrencies( this.lsPaymentStatements) ;
                   this. resetPaymentDet();
               
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_SYSTEM_DEPOSIT,
                          "error in onNewDueAmount",
                          err.toString(),
                          "onNewDueAmount",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                
                }, 





            onChangeDate(pDateList) {
          try {
            if(BaseConfiguration.isDebug) console.log("onChangeDate");
          //  console.error(pDateList)
        //    this.fromDate=pDateList[0]._d;
           this.setReportFromDate(pDateList[0]._d);
           this.setReportToDate(pDateList[1]._d);
            //  this.toDate=pDateList[1]._d;
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_SYSTEM_DEPOSIT,
                    "error in onChangeDate",
                    err.toString(),
                    "onChangeDate",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
          }, 
        getMinYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMinYear");
           retValue=(new Date().getFullYear()-10)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_SYSTEM_DEPOSIT,
                    "error in getMinYear",
                    err.toString(),
                    "getMinYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 
      getMaxYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMaxYear");
           retValue=(new Date().getFullYear()+1)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_SYSTEM_DEPOSIT,
                    "error in getMaxYear",
                    err.toString(),
                    "getMaxYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 

            getStatusCountForAgent(pPostPaidStatus) {
                  let retValue=0;

                try {
                  if(BaseConfiguration.isDebug) console.log("getStatusCountForAgent");
                  if(this.selAgentObj&&this.selAgentObj.list){
                 for(let i=0;i<this.selAgentObj.list.length;i++){
                          for (let k = 0; k < Object.keys(this.selAgentObj.list[i]).length; k++) {
                         if (Object.keys(this.selAgentObj.list[i])[k] != 'fromDate' && Object.keys(this.selAgentObj.list[i])[k] != 'toDate') {
                           
                        if(pPostPaidStatus==POSTPAID_STATEMENT_STATUS.PAID){
                            if(this.selAgentObj.list[i][Object.keys(this.selAgentObj.list[i])[k]].statementStatus==POSTPAID_STATEMENT_STATUS.PAID||
                            this.selAgentObj.list[i][Object.keys(this.selAgentObj.list[i])[k]].statementStatus == POSTPAID_STATEMENT_STATUS.EMPTY){
                                retValue=retValue+1;

                            }

                            }else if(pPostPaidStatus==this.selAgentObj.list[i][Object.keys(this.selAgentObj.list[i])[k]].statementStatus){
                                retValue=retValue+1;

                            }
                         }
                         }
                    
                 }
                  }
                         
                       
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_SYSTEM_DEPOSIT,
                          "error in getStatusCountForAgent",
                          err.toString(),
                          "getStatusCountForAgent",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
                }, 

            getPayNewAmount(pPayNewAmount, pPayableAmount, pPaymentCurrency) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getPayNewAmount");
                    retValue = pPayNewAmount != null
                        ? pPayNewAmount
                        : 
                           this.$options.filters.currencyFormat(
                            pPayableAmount,
                            "USD"
                        );
                     

                    if (retValue && typeof retValue == 'number' && retValue.toString().match(/^[0-9.,]*$/) == null) {
                        retValue = null;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPayNewAmount",
                        err.toString(),
                        "getPayNewAmount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getMaxCharacters(pTopUpAmt) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getMaxCharacters");
                    let retMaxValue = getMaxCharOfAmount(pTopUpAmt);
                    if (pTopUpAmt) {
                        let indexOfDot = pTopUpAmt.toString().indexOf(".");
                        //  console.error("index",indexOfDot);

                        if (retMaxValue > 15 && indexOfDot < 15) {
                            retMaxValue = retMaxValue;
                        } else {
                            retMaxValue = 15;
                        }
                        if (typeof retMaxValue != 'number') {
                            retMaxValue = 15;
                        }
                    } else {
                        retMaxValue = 15;
                    }


                    return retMaxValue;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getMaxCharacters",
                        err.toString(),
                        "getMaxCharacters",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            getTransactionType(pTransactionType) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getTransactionType");


                    switch (pTransactionType) {
                        case TRANSACTION_TYPE.Postpaid_Booking:
                            retValue = this.$t('deposit.postpaidBooking');
                            break;
                        case TRANSACTION_TYPE.Prepaid_Booking:
                            retValue = this.$t('deposit.prepaidBooking');
                            break;
                        case TRANSACTION_TYPE.Postpaid_Credit:
                            retValue = this.$t('deposit.postpaidCredit');
                            break;
                        case TRANSACTION_TYPE.Postpaid_Debit:
                            retValue = this.$t('deposit.postpaidDebit');
                            break;
                        case TRANSACTION_TYPE.Prepaid_Credit:
                            retValue = this.$t('deposit.prepaidCredit');
                            break;
                        case TRANSACTION_TYPE.Prepaid_Debit:
                            retValue = this.$t('deposit.prepaidDebit');
                            break;
                        case TRANSACTION_TYPE.Postpaid_Payment:
                            retValue = this.$t('deposit.postpaidPayment');
                            break;
                        case TRANSACTION_TYPE.Prepaid_Topup:
                            retValue = this.$t('deposit.prepaidTopup');
                            break;

                        default:
                            break;
                    }


                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getTransactionType",
                        err.toString(),
                        "getTransactionType",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getExcelFileName(pFileName) {
                let retValue;

                try {
                    if (BaseConfiguration.isDebug) console.log("getExcelFileName");
                    let excelDate = this.$options.filters.formatDate(new Date());
                    retValue = pFileName + ' - ' + excelDate + '.xlsx';
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getExcelFileName",
                        err.toString(),
                        "getExcelFileName",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getExtendStartDateValue(pCurrDueDate) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getExtendStartDateValue");
                    // retValue = addDays(pCurrDueDate, 1);

                     if (getDiffBtwDates(
                            new Date(pCurrDueDate),
                            new Date(),
                            "days"
                        ) > 0) {
                      retValue = addDays(pCurrDueDate, 1);
                         } else if (getDiffBtwDates(
                            new Date(pCurrDueDate),
                            new Date(),
                            "days"
                        ) == 0 && formatDate(pCurrDueDate, 'DD') == formatDate(Date(), 'DD')) {
                           retValue = addDays(pCurrDueDate, 1);

                        }else{
                            retValue=addDays(new Date(), 1);
                        }

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getExtendStartDateValue",
                        err.toString(),
                        "getExtendStartDateValue",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getExtendEndDateValue(stmntExtendDet) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getExtendStartDateValue");
                    // retValue = addDays(stmntExtendDet.currDueDate, stmntExtendDet.canExtendDays);
 if (getDiffBtwDates(
                            new Date(stmntExtendDet.currDueDate),
                            new Date(),
                            "days"
                        ) > 0) {
                    retValue = addDays(stmntExtendDet.currDueDate, stmntExtendDet.canExtendDays);
                         } else if (getDiffBtwDates(
                            new Date(stmntExtendDet.currDueDate),
                            new Date(),
                            "days"
                        ) == 0 && formatDate(stmntExtendDet.currDueDate, 'DD') == formatDate(Date(), 'DD')) {
                    retValue = addDays(stmntExtendDet.currDueDate, stmntExtendDet.canExtendDays);

                        }else{
                    retValue = addDays(new Date(), stmntExtendDet.canExtendDays);
                        }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getExtendStartDateValue",
                        err.toString(),
                        "getExtendStartDateValue",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getTripCategory(pJourneyType) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getTripCategory");
                    if (pJourneyType == 1) {
                        return this.$t('deposit.oneWay');
                    } else if (pJourneyType == 2) {
                        return this.$t('deposit.roundTrip')
                    } else if (pJourneyType == 3) {
                        return this.$t('deposit.multiCity')
                    } else {
                        return '';
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getTripCategory",
                        err.toString(),
                        "getTripCategory",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getTitleForModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("getTitleForModal");
                    return this.isTotalDueAmtPopUp ? this.$t('deposit.transactionStatement') : this.$t('deposit.paymentHis')
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getTitleForModal",
                        err.toString(),
                        "getTitleForModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getFileName() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getFileName");
                    let excelDate = this.$options.filters.formatDate(new Date());
                    let fileName = this.isTotalDueAmtPopUp ? this.$t("deposit.transactionStmtFileNme") : this.$t("deposit.payHistoryFileName");
                    retValue = fileName + ' - ' + excelDate + '.xlsx';
                    //  return this.isTotalDueAmtPopUp?'Transaction Statement':'Payment History';

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getFileName",
                        err.toString(),
                        "getFileName",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;

            },
            clearStatementNoDp() {
                try {
                    if (BaseConfiguration.isDebug) console.log("clearStatementNoDp");
                    this.selStatement = null;
                    if (this.isSingleAgent) {
                        this.agent = this.selAgentObj;
                    } else {
                        this.lsPostpaidStatements = JSON.parse(
                            JSON.stringify(this.postpaidStmntRes)
                        );
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in clearStatementNoDp",
                        err.toString(),
                        "clearStatementNoDp",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },


            clearAgent() {
                try {
                    if (BaseConfiguration.isDebug) console.log("clearAgent");
                    let selStatement = cloneDeep(this.selStatement);

                    this.navToAllAgentSelection();
                    this.selStatement = selStatement;
                    if (this.selStatement) {
                        this.onFilterByStatementNo();
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in clearAgent",
                        err.toString(),
                        "clearAgent",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },


            onHideSuccDeposit() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onHideSuccDeposit");
                    this.isDepositSuccess = false;
                    this.showConfirmModal = false;

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in onHideSuccDeposit",
                        err.toString(),
                        "onHideSuccDeposit",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            getExtendDueDateBtn(pStatement) {
                let retValue = null;

                try {
                    if (BaseConfiguration.isDebug) console.log("getExtendDueDateBtn");
                    for (let i = 0; i < Object.keys(pStatement).length; i++) {
                        if (Object.keys(pStatement)[i] != 'fromDate' && Object.keys(pStatement)[i] != 'toDate') {
                            // if(pStatement[Object.keys(pStatement)[i]].canExtend){
                            retValue = pStatement[Object.keys(pStatement)[i]].canExtend;


                            // }
                            break;

                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getExtendDueDateBtn",
                        err.toString(),
                        "getExtendDueDateBtn",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getOverDueDays(pStatement) {
                let retValue = null;

                try {
                    if (BaseConfiguration.isDebug) console.log("getOverDueDays");
                    for (let i = 0; i < Object.keys(pStatement).length; i++) {
                        if (Object.keys(pStatement)[i] != 'fromDate' && Object.keys(pStatement)[i] != 'toDate') {
                            if (pStatement[Object.keys(pStatement)[i]].overdue_days) {
                                if (pStatement[Object.keys(pStatement)[i]].overdue_days == 1) {
                                    retValue = pStatement[Object.keys(pStatement)[i]].overdue_days + ' day ago';
                                } else if (pStatement[Object.keys(pStatement)[i]].overdue_days > 1) {
                                    retValue = pStatement[Object.keys(pStatement)[i]].overdue_days + ' days ago';

                                }


                            }
                            break;

                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getOverDueDays",
                        err.toString(),
                        "getOverDueDays",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            navToAllAgentSelection() {
                try {
                    if (BaseConfiguration.isDebug) console.log("navToAllAgentSelection");
                    if (this.isViewOnly) {
                        this.allAgent.details = {agencyname: DEFAULT_DROPDOWN_STATUS.ALL, b2bid: null};
                        this.agent = {agencyname: DEFAULT_DROPDOWN_STATUS.ALL, b2bid: null};

                        this.onAllAgentChange(this.agent)
                    } else {
                        this.agent = {agencyName: DEFAULT_DROPDOWN_STATUS.ALL, b2bid: null};

                        this.onAgentChange(this.agent);

                    }
                    //  this.selStatement=null;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in navToAllAgentSelection",
                        err.toString(),
                        "navToAllAgentSelection",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            statementCustomLabel(option) {
                return `${option.statementNo} — [${option.statementNo}]`;
            },
            onFilterByStatementNo() {

                try {
                    if (BaseConfiguration.isDebug) console.log("onFilterByStatementNo");
                    // let postPaidStatements=this.lsPostpaidStatements;
                    // this.postpaid.isPastDueDate = false;
                    this.clearAllFilters();
                    this.SET_OVER_DUE_FILTER(false);

                    if (this.isSingleAgent && this.selAgentObj && this.selAgentObj.list) {

                        let agent = JSON.parse(
                            JSON.stringify(this.selAgentObj)
                        );

                        let agentObj = JSON.parse(
                            JSON.stringify(this.selAgentObj)
                        );
                        for (let p = 0; p < agent.list.length; p++) {
                            for (let k = 0; k < Object.keys(agent.list[p]).length; k++) {
                                if (Object.keys(agent.list[p])[k] != 'fromDate' && Object.keys(agent.list[p])[k] != 'toDate') {
                                    //  Object.values(lsAllPostpaidStatements.list[j])[k]
                                    if (Object.values(agent.list[p])[k].statementNo != this.selStatement.statementNo) {
                                        this.$delete(agentObj.list[p], Object.keys(agent.list[p])[k]);

                                    }
                                }
                            }
                        }

                        let lsStatements = [];

                        for (let s = 0; s < agentObj.list.length; s++) {
                            if (Object.keys(agentObj.list[s]).length > 2) {
                                lsStatements.push(agentObj.list[s]);
                                // this.$delete(agentObj.list,s);

                            }
                            //  console.error(lsStatements)


                        }
                        agentObj.list = lsStatements;
                        this.agent = agentObj;
                        this.agentListByStatementNo = this.agent;

                    } else {

                        let postpaidStatements = JSON.parse(
                            JSON.stringify(this.postpaidStmntRes)
                        );
                        let lsPostpaidStatements = cloneDeep(this.postpaidStmntRes);
                        for (let i = 0; i < postpaidStatements.length; i++) {
                            for (let j = 0; j < postpaidStatements[i].list.length; j++) {
                                for (let k = 0; k < Object.keys(postpaidStatements[i].list[j]).length; k++) {
                                    if (Object.keys(postpaidStatements[i].list[j])[k] != 'fromDate' && Object.keys(postpaidStatements[i].list[j])[k] != 'toDate') {
                                        if (Object.values(postpaidStatements[i].list[j])[k].statementNo != this.selStatement.statementNo) {
                                            this.$delete(lsPostpaidStatements[i].list[j], Object.keys(postpaidStatements[i].list[j])[k]);

                                        }

                                    }
                                }
                            }
                        }

                        for (let l = 0; l < lsPostpaidStatements.length; l++) {
                            let listStatements = [];

                            for (let m = 0; m < lsPostpaidStatements[l].list.length; m++) {
                                if (Object.keys(lsPostpaidStatements[l].list[m]).length > 2) {
                                    listStatements.push(lsPostpaidStatements[l].list[m]);

                                }

                            }
                            lsPostpaidStatements[l].list = listStatements;
                        }
                        this.lsPostpaidStatements = cloneData(lsPostpaidStatements);
                        let count = 0;
                        for (let i = 0; i < this.lsPostpaidStatements.length; i++) {
                            count = count + this.lsPostpaidStatements[i].list.length;
                        }
                        this.cSystemDepositWatchList.filteredlistCount = count;
                    }
                    this.postPaidListByStatementNo = this.lsPostpaidStatements;

                    this.resetPaymentDet();
                    this.resetNewDueAmount()

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in onFilterByStatementNo",
                        err.toString(),
                        "onFilterByStatementNo",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            getStatementNoOptionLs() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getStatementNoOptionLs");
                    if (this.isSingleAgent) {
                        let postpaidStatements = this.selAgentObj ? this.selAgentObj : this.agent;
                        let lsStatementNo = [];
                        if(postpaidStatements){
                          for (let j = 0; j < postpaidStatements.list.length; j++) {
                            for (let k = 0; k < Object.keys(postpaidStatements.list[j]).length; k++) {
                                if (Object.keys(postpaidStatements.list[j])[k] != 'fromDate' && Object.keys(postpaidStatements.list[j])[k] != 'toDate') {
                                    lsStatementNo.push(Object.values(postpaidStatements.list[j])[k]);
                                }
                            }
                        }
                        }
                        
                        if(this.selStatement){
                       this.selStatement=this.checkAndAssignStatementNo(this.selStatement,lsStatementNo);

                        }
                         lsStatementNo=OrderBy(lsStatementNo,'statementNo',ORDER.ASC)
                        retValue = lsStatementNo;
                    } else {


                        let postpaidStatements = this.lsPostpaidStatements;
                        let lsStatementNo = [];
                        for (let i = 0; i < postpaidStatements.length; i++) {
                            for (let j = 0; j < postpaidStatements[i].list.length; j++) {
                                for (let k = 0; k < Object.keys(postpaidStatements[i].list[j]).length; k++) {
                                    if (Object.keys(postpaidStatements[i].list[j])[k] != 'fromDate' && Object.keys(postpaidStatements[i].list[j])[k] != 'toDate') {
                                        lsStatementNo.push(Object.values(postpaidStatements[i].list[j])[k]);
                                    }
                                }
                            }
                        }
                         if(this.selStatement){
                       this.selStatement=this.checkAndAssignStatementNo(this.selStatement,lsStatementNo);

                        }
                                                 lsStatementNo=OrderBy(lsStatementNo,'statementNo',ORDER.ASC)

                        retValue = lsStatementNo;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getStatementNoOptionLs",
                        err.toString(),
                        "getStatementNoOptionLs",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getTotalPages() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getTotalPages");
                    if (this.cSystemDepositWatchList.filteredlistCount != null) {
                        let totalPages = this.cSystemDepositWatchList.filteredlistCount / this.cSystemDepositWatchList.itemsPerPage;
                        retValue = Math.ceil(totalPages);


                        if (retValue <= 0) {
                            retValue = 1;
                        }
                    } else {
                        retValue = 1;
                    }


                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getTotalPages",
                        err.toString(),
                        "getTotalPages",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getStatementsCountForAgntView(pIndex) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getStatementsCountForAgntView");
                    let count = 0;


                    count = pIndex + 1;


                    if (count >= this.getStartValueCount() && count <= this.getFilteredListPerPage()) {
                        return true;
                    } else {
                        return false;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getStatementsCountForAgntView",
                        err.toString(),
                        "getStatementsCountForAgntView",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            getStatementsCountForView(pIndex, pSIndex) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getStatementsCountForView");
                    let count = 0;
                    if (pIndex == 0) {
                        count = pSIndex + 1;
                    } else {
                        for (let i = 0; i < pIndex; i++) {
                            count = count + this.lsPostpaidStatements[i].list.length;
                        }
                        count = count + (pSIndex + 1)

                    }


                    if (count >= this.getStartValueCount() && count <= this.getFilteredListPerPage()) {
                        return true;
                    } else {
                        return false;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getStatementsCountForView",
                        err.toString(),
                        "getStatementsCountForView",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            getStartValueCount() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getStartValueCount");
                    if (this.cSystemDepositWatchList.filteredlistCount == 0) {
                        retValue = 0;
                    } else {
                        if (
                            this.cSystemDepositWatchList.itemsPerPage <
                            this.cSystemDepositWatchList.filteredlistCount
                        ) {
                            retValue =
                                (this.cSystemDepositWatchList.currentPageNum - 1) *
                                this.cSystemDepositWatchList.itemsPerPage;
                            retValue = retValue + 1;
                        } else {
                            retValue = 1;
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_PAGINATION_LEN_OPTION,
                        "error in getStartValueCount",
                        err.toString(),
                        "getStartValueCount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getFilteredListPerPage() {
                let retValue;

                try {
                    if (BaseConfiguration.isDebug) console.log("getFilteredListPerPage");
                    if (
                        this.cSystemDepositWatchList.itemsPerPage <
                        this.cSystemDepositWatchList.filteredlistCount
                    ) {
                        if (
                            this.cSystemDepositWatchList.currentPageNum *
                            this.cSystemDepositWatchList.itemsPerPage >
                            this.cSystemDepositWatchList.filteredlistCount
                        ) {
                            retValue = this.cSystemDepositWatchList.filteredlistCount;
                        } else {
                            retValue =
                                this.cSystemDepositWatchList.currentPageNum *
                                this.cSystemDepositWatchList.itemsPerPage;
                        }
                    } else {
                        retValue = this.cSystemDepositWatchList.filteredlistCount;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_PAGINATION_LEN_OPTION,
                        "error in getFilteredListPerPage",
                        err.toString(),
                        "getFilteredListPerPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getAmountWithFormat(pAmount, pCurr) {

                try {
                    if (BaseConfiguration.isDebug) console.log("getAmountWithFormat");

                    return this.$options.filters.formatNumber(pAmount, pCurr);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getAmountWithFormat",
                        err.toString(),
                        "getAmountWithFormat",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            async onClickHyperLink(pTitle, pStmntCurr, pAgent) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onClickHyperLink");
                    this.selHisAgent = pAgent;
                    this.hyperLinkSelStatement = pStmntCurr;
                    if (pTitle == 'paidAmount' &&
                        (pStmntCurr.statementStatus !=
                            POSTPAID_STATEMENT_STATUS.NEW && pStmntCurr.statementStatus != POSTPAID_STATEMENT_STATUS.EMPTY)) {
                        this.isTotalDueAmtPopUp = false;

                        this.getPaymentHistory(
                            pStmntCurr.statementNo,
                            pAgent.b2bid,
                            pAgent
                        );
                    } else if (pTitle == 'invoice' && pStmntCurr[pTitle] != 0) {
                        this.showInvoiceModal = true;
                        this.lsInvoices = null;
                        this.lsInvoices = await this.getInvoiceDetail(pStmntCurr.statementNo,
                            pAgent.b2bid)
                    } else if (pTitle == 'dueAmount' && (pStmntCurr.statementStatus !=
                        POSTPAID_STATEMENT_STATUS.NEW && pStmntCurr.statementStatus != POSTPAID_STATEMENT_STATUS.EMPTY)) {
                        this.isTotalDueAmtPopUp = true;
                        this.getPaymentHistory(
                            pStmntCurr.statementNo,
                            pAgent.b2bid,
                            pAgent
                        );
                    } else if (pTitle == 'dueDate') {
                        this.showDueDateHisModal = true;
                        this.lsDueDateHistory = null;


                        this.getPaymentHisForExtendDueDate(pStmntCurr.statementNo)

                    }


                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in onClickHyperLink",
                        err.toString(),
                        "onClickHyperLink",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            async getInvoiceDetail(pStmntId, pB2BId) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getInvoiceDetail");

                    if (pStmntId && pB2BId) {
                        let invoiceReq = apiGetInvoiceDetail.buildRequest(
                            pStmntId,
                            pB2BId
                        );

                        if (invoiceReq) {
                            let invoiceRes = await apiGetInvoiceDetail.getResponse(
                                invoiceReq
                            );

                            if (VALIDATE_SUCCESS_RES(invoiceRes)) {
                                this.alertValue = null;

                                retValue = invoiceRes.data.data;

                            } else {
                                let error = getErrorMessage(invoiceRes);

                                let isJwt = handleJWT(error);
                                if (!isJwt) {
                                    this.alertValue = getErrorAlertValue(error);

                                }
                            }
                        } else {
                            throw "invalid  postpaid payment invoice  request";
                        }
                    } else {
                        throw "invalid request data";
                    }
                    return retValue;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getInvoiceDetail",
                        err.toString(),
                        "getInvoiceDetail",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getOverDueClass(pDueDate, pStmntCurr) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getOverDueClass");
                    if (pStmntCurr.statementStatus != POSTPAID_STATEMENT_STATUS.PAID && pStmntCurr.statementStatus != POSTPAID_STATEMENT_STATUS.EMPTY) {


                        if (getDiffBtwDates(
                            new Date(pDueDate),
                            new Date(),
                            "days"
                        ) > 0) {
                            return false;
                        } else if (getDiffBtwDates(
                            new Date(pDueDate),
                            new Date(),
                            "days"
                        ) == 0 && formatDate(pDueDate, 'DD') == formatDate(Date(), 'DD')) {
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        return false;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getOverDueClass",
                        err.toString(),
                        "getOverDueClass",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            filterStatements(pPostPaid) {
                try {
                    if (BaseConfiguration.isDebug) console.log("filterStatements");
                    this.selStatement = null;
                    if (this.isSingleAgent && this.selAgentObj && this.selAgentObj.list) {
                        if (pPostPaid.isPastDueDate||pPostPaid.isPaid) {
                            let agent = JSON.parse(
                                JSON.stringify(this.selAgentObj)
                            );


                            let agentObj = JSON.parse(
                                JSON.stringify(this.selAgentObj)
                            );
                            for (let p = 0; p < agent.list.length; p++) {
                                for (let k = 0; k < Object.keys(agent.list[p]).length; k++) {
                                    if (Object.keys(agent.list[p])[k] != 'fromDate' && Object.keys(agent.list[p])[k] != 'toDate') {
                                        //  Object.values(lsAllPostpaidStatements.list[j])[k]
                                        if(pPostPaid.isPastDueDate&&!pPostPaid.isPaid){

                                        
                                        if (agent.list[p][Object.keys(agent.list[p])[k]].statementStatus == POSTPAID_STATEMENT_STATUS.PAID || agent.list[p][Object.keys(agent.list[p])[k]].statementStatus == POSTPAID_STATEMENT_STATUS.EMPTY) {
                                            this.$delete(agentObj.list[p], Object.keys(agent.list[p])[k]);
                                        } else if (getDiffBtwDates(
                                            new Date(agent.list[p][Object.keys(agent.list[p])[k]].dueDate),
                                            new Date(),
                                            "days"
                                        ) > 0) {


                                            this.$delete(agentObj.list[p], Object.keys(agent.list[p])[k]);
                                        } else if (getDiffBtwDates(
                                            new Date(agent.list[p][Object.keys(agent.list[p])[k]].dueDate),
                                            new Date(),
                                            "days"
                                        ) == 0 && formatDate(agent.list[p][Object.keys(agent.list[p])[k]].dueDate, 'DD') == formatDate(Date(), 'DD')) {
                                            this.$delete(agentObj.list[p], Object.keys(agent.list[p])[k]);
                                        }
                                    }else if(pPostPaid.isPaid&&!pPostPaid.isPastDueDate){
                                      if (agent.list[p][Object.keys(agent.list[p])[k]].statementStatus != POSTPAID_STATEMENT_STATUS.PAID ) {
                                            this.$delete(agentObj.list[p], Object.keys(agent.list[p])[k]);
                                        }
                                    }else if(pPostPaid.isPaid&&pPostPaid.isPastDueDate){
                                         if (agent.list[p][Object.keys(agent.list[p])[k]].statementStatus == POSTPAID_STATEMENT_STATUS.EMPTY) {
                                            this.$delete(agentObj.list[p], Object.keys(agent.list[p])[k]);
                                        } else if (getDiffBtwDates(
                                            new Date(agent.list[p][Object.keys(agent.list[p])[k]].dueDate),
                                            new Date(),
                                            "days"
                                        ) > 0&&agent.list[p][Object.keys(agent.list[p])[k]].statementStatus != POSTPAID_STATEMENT_STATUS.PAID ) {


                                            this.$delete(agentObj.list[p], Object.keys(agent.list[p])[k]);
                                        } else if (getDiffBtwDates(
                                            new Date(agent.list[p][Object.keys(agent.list[p])[k]].dueDate),
                                            new Date(),
                                            "days"
                                        ) == 0 && formatDate(agent.list[p][Object.keys(agent.list[p])[k]].dueDate, 'DD') == formatDate(Date(), 'DD')&&agent.list[p][Object.keys(agent.list[p])[k]].statementStatus != POSTPAID_STATEMENT_STATUS.PAID ) {
                                            this.$delete(agentObj.list[p], Object.keys(agent.list[p])[k]);
                                        }
              
                                    }
                                    }
                                }
                            }

                            let lsStatements = [];

                            for (let s = 0; s < agentObj.list.length; s++) {
                                if (Object.keys(agentObj.list[s]).length > 2) {
                                    lsStatements.push(agentObj.list[s]);
                                    // this.$delete(agentObj.list,s);

                                }
                                //  console.error(lsStatements)


                            }
                            agentObj.list = lsStatements;
                            this.agent = agentObj;
                        } else {
                            if (this.selStatement) {
                                this.agent = this.agentListByStatementNo;
                            } else {
                                this.agent = this.selAgentObj;

                            }
                            this.SET_OVER_DUE_FILTER(false);
                        }
                    } else {
                        if (this.postpaidStmntRes && this.postpaidStmntRes.length) {

                            let lsAllPostpaidStatements;
                            let lsPostpaidStatements;
                            if (this.selStatement) {
                                lsAllPostpaidStatements = JSON.parse(
                                    JSON.stringify(this.lsPostpaidStatements)
                                );
                                lsPostpaidStatements = cloneDeep(this.lsPostpaidStatements);
                            } else {
                                lsAllPostpaidStatements = JSON.parse(
                                    JSON.stringify(this.postpaidStmntRes)
                                );
                                lsPostpaidStatements = cloneDeep(this.postpaidStmntRes);

                            }
                            if (pPostPaid.isPastDueDate) {
                                for (let i = 0; i < lsAllPostpaidStatements.length; i++) {
                                    for (let j = 0; j < lsAllPostpaidStatements[i].list.length; j++) {
                                        for (let k = 0; k < Object.keys(lsAllPostpaidStatements[i].list[j]).length; k++) {
                                            if (Object.keys(lsAllPostpaidStatements[i].list[j])[k] != 'fromDate' && Object.keys(lsAllPostpaidStatements[i].list[j])[k] != 'toDate') {
                                                //  Object.values(lsAllPostpaidStatements.list[j])[k]
                                                if (lsAllPostpaidStatements[i].list[j][Object.keys(lsAllPostpaidStatements[i].list[j])[k]].statementStatus == POSTPAID_STATEMENT_STATUS.PAID || lsAllPostpaidStatements[i].list[j][Object.keys(lsAllPostpaidStatements[i].list[j])[k]].statementStatus == POSTPAID_STATEMENT_STATUS.EMPTY) {
                                                    this.$delete(lsPostpaidStatements[i].list[j], Object.keys(lsAllPostpaidStatements[i].list[j])[k]);
                                                } else if (getDiffBtwDates(
                                                    new Date(lsAllPostpaidStatements[i].list[j][Object.keys(lsAllPostpaidStatements[i].list[j])[k]].dueDate),
                                                    new Date(),
                                                    "days"
                                                ) > 0) {
                                                    this.$delete(lsPostpaidStatements[i].list[j], Object.keys(lsAllPostpaidStatements[i].list[j])[k]);

                                                } else if (getDiffBtwDates(
                                                    new Date(lsAllPostpaidStatements[i].list[j][Object.keys(lsAllPostpaidStatements[i].list[j])[k]].dueDate),
                                                    new Date(),
                                                    "days"
                                                ) == 0 && (formatDate(lsAllPostpaidStatements[i].list[j][Object.keys(lsAllPostpaidStatements[i].list[j])[k]].dueDate, 'DD') == formatDate(Date(), 'DD'))) {
                                                    this.$delete(lsPostpaidStatements[i].list[j], Object.keys(lsAllPostpaidStatements[i].list[j])[k]);
                                                }
                                            }
                                        }
                                    }
                                }

                                for (let l = 0; l < lsPostpaidStatements.length; l++) {
                                    let listStatements = [];

                                    for (let m = 0; m < lsPostpaidStatements[l].list.length; m++) {
                                        if (Object.keys(lsPostpaidStatements[l].list[m]).length > 2) {
                                            listStatements.push(lsPostpaidStatements[l].list[m]);

                                        }

                                    }
                                    lsPostpaidStatements[l].list = listStatements;
                                }
                                this.lsPostpaidStatements = cloneData(lsPostpaidStatements);
                                let count = 0;
                                for (let i = 0; i < this.lsPostpaidStatements.length; i++) {
                                    count = count + this.lsPostpaidStatements[i].list.length;
                                }
                                this.cSystemDepositWatchList.filteredlistCount = count;

                            } else {
                                if (this.selStatement) {
                                    this.lsPostpaidStatements = this.postPaidListByStatementNo;
                                } else {
                                    this.lsPostpaidStatements = cloneData(lsPostpaidStatements);

                                }
                                this.SET_OVER_DUE_FILTER(false);
                            }
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SYSTEM_DEPOSIT,
                        "error in filterStatements",
                        err.toString(),
                        "filterStatements",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                ;
            },
            getExcelTitle() {
                let retValue = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("getExcelTitle");
                    let agentDet = "";
                    let selHisAgent = "";
                    if (this.agent && this.agentDetail) {
                        agentDet = [
                            `${this.agent.agencyName} (${this.agent.b2bCode})`,


                        ];
                    }
                    if (this.selHisAgent && this.selHisAgent.agencyName && this.selHisAgent.b2bCode) {
                        selHisAgent = [
                            `${this.selHisAgent.agencyName} (${this.selHisAgent.b2bCode})`,

                        ];
                    }

                    let reportPeriod = `${this.formatDate(this.postpaidStatement.fromDate)}   ${this.$t("deposit.to")}    ${this.formatDate(this.postpaidStatement.toDate)}`;
                    let statementNo = this.hyperLinkSelStatement && this.hyperLinkSelStatement.statementNo ? this.$t('deposit.statementNo') + '  ' + this.hyperLinkSelStatement.statementNo : '';


                    if (this.isSingleAgent) retValue = [agentDet, reportPeriod];
                    else if (this.showPayHisJsonExcelModal) retValue = [selHisAgent, this.isTotalDueAmtPopUp ? this.$t('deposit.transactionStatement') : this.$t('deposit.paymentHistory'), this.$t('deposit.statementPeriod') + ':' + reportPeriod, statementNo];
                    else if (this.showInvoiceJsonExcelModal) retValue = [selHisAgent, this.$t('deposit.invoices'), this.$t('deposit.statementPeriod') + ':' + reportPeriod, statementNo];

                    else if (this.showDueDateJsonExcelModal) retValue = [selHisAgent, this.$t('deposit.extendDueDateHis'), this.$t('deposit.statementPeriod') + ':' + reportPeriod, statementNo];
                    else retValue = [reportPeriod];
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getExcelTitle",
                        err.toString(),
                        "getExcelTitle",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            //       getPrintPostPaidStatements() {
            //   let retValue = [];

            //   try {
            //     if (BaseConfiguration.isDebug) console.log("getPrintPostPaidStatements");
            //     let listPostPaid=[];
            //     let postPaidList = JSON.parse(
            //       JSON.stringify(this.lsPostpaidStatements)
            //     );
            //     for(let i=0;i<postPaidList.length;i++){
            //       let postPaidObj={};
            //       for(let j=0;j<postPaidList[i].list.length;j++){
            //         for(let k=0;k<Object.keys(postPaidList[i].list).length;k++){
            //        postPaidObj={
            //         status:this.getPostPaidStatus(Object.values(postPaidList[i].list)[k].statementStatus),
            //         agencyName:postPaidList[i].agencyName,
            //         statementNo:Object.values(postPaidList[i].list)[k].statementNo,
            //         invoice:Object.values(postPaidList[i].list)[k].invoice,
            //         paymentDueDate:Object.values(postPaidList[i].list)[k].dueDate,
            //         currency:Object.keys(postPaidList[i].list)[k],
            //         totalDueAmount:Object.values(postPaidList[i].list)[k].dueAmount,
            //         paidAmount:Object.values(postPaidList[i].list)[k].paidAmount,
            //         balanceDue:Object.values(postPaidList[i].list)[k].balanceDue

            //       }
            //         }

            //       }
            //     }


            //     retValue = cloneData(invoiceList);
            //   } catch (err) {
            //     let body = Logger.buildRequest(
            //       FILE_NAME.C_SYSTEM_DEPOSIT,
            //       "error in getPrintPostPaidStatements",
            //       err.toString(),
            //       "getPrintPostPaidStatements",
            //       LOG_TYPE.ERROR
            //     );
            //     Logger.getResponse(body);
            //   }
            //   return retValue;
            // },
            // getPostPaidStatus(pStatementStatus) {
            //   let retValue;
            //     try {
            //       if(BaseConfiguration.isDebug) console.log("getPostPaidStatus");

            //        if(pStatementStatus==POSTPAID_STATEMENT_STATUS.PAID ||POSTPAID_STATEMENT_STATUS.EMPTY){
            //          retValue='Paid'
            //        }else if(pStatementStatus ==
            //                                 POSTPAID_STATEMENT_STATUS.PARTIALLY_PAID){
            //                              retValue='Partial Paid'
            //          }else if(pStatementStatus ==
            //                                 POSTPAID_STATEMENT_STATUS.NEW){
            //                                    retValue='Unpaid'
            //                                 }

            //     } catch (err) {
            //             let body = Logger.buildRequest(
            //               FILE_NAME.C_SYSTEM_DEPOSIT,
            //               "error in getPostPaidStatus",
            //               err.toString(),
            //               "getPostPaidStatus",
            //               LOG_TYPE.ERROR
            //             );
            //             Logger.getResponse(body);
            //           }
            //       return retValue;
            //     },

            getPrintInvoices() {
                let retValue = [];

                try {
                    if (BaseConfiguration.isDebug) console.log("getPrintInvoices");

                    let invoiceList = JSON.parse(
                        JSON.stringify(this.lsInvoices)
                    );
                    // let lsPrintStatements = [];


                    if(invoiceList && invoiceList.length)
                    for (let i = 0; i < invoiceList.length; i++) {
                        invoiceList[i].transactiontype = this.getTransactionType(invoiceList[i].transactiontype);

                        invoiceList[i].date = this.$options.filters.formatDate(invoiceList[i].date);
                        invoiceList[i].amount = invoiceList[i].amount
                        invoiceList[i].journeytype = this.getTripCategory(invoiceList[i].journeytype);
                        let route = '';
                        for (let j = 0; j < invoiceList[i].route.length; j++) {
                            invoiceList[i].route[j] = invoiceList[i].route[j] + ",";
                            route = route + invoiceList[i].route[j];
                        }

                        invoiceList[i].route = route
                            .toString()
                            .split(",")
                            .join("\n");
                    }

                    retValue = cloneData(invoiceList);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPrintInvoices",
                        err.toString(),
                        "getPrintInvoices",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getPrintPayHis() {
                let retValue = [];

                try {
                    if (BaseConfiguration.isDebug) console.log("getPrintPayHis");

                    let lsPaymentHistory = JSON.parse(
                        JSON.stringify(this.lsPaymentHis)
                    );
                    // let lsPrintStatements = [];
                    for (let i = 0; i < lsPaymentHistory.length; i++) {
                        lsPaymentHistory[i].date = this.$options.filters.formatDateTime(lsPaymentHistory[i].date, this.defaultDateTimeFormat);
                        if (!this.isTotalDueAmtPopUp) {
                            lsPaymentHistory[i].paidamount = lsPaymentHistory[i].paidamount, lsPaymentHistory[i].currency;
                            lsPaymentHistory[i].pendingamount = lsPaymentHistory[i].pendingamount, lsPaymentHistory[i].currency;

                        }

                    }

                    retValue = cloneData(lsPaymentHistory);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPrintPayHis",
                        err.toString(),
                        "getPrintStatements",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getPrintDueDateHis() {
                let retValue = [];

                try {
                    if (BaseConfiguration.isDebug) console.log("getPrintDueDateHis");

                    let lsPaymentHistory = JSON.parse(
                        JSON.stringify(this.lsDueDateHistory)
                    );
                    // let lsPrintStatements = [];
                    for (let i = 0; i < lsPaymentHistory.length; i++) {
                        lsPaymentHistory[i].old_date = this.$options.filters.formatDate(lsPaymentHistory[i].old_date);
                        lsPaymentHistory[i].new_date = this.$options.filters.formatDate(lsPaymentHistory[i].new_date);
                        lsPaymentHistory[i].ts = this.$options.filters.formatDateTime(lsPaymentHistory[i].ts,this.defaultDateTimeFormat);


                    }

                    retValue = cloneData(lsPaymentHistory);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPrintDueDateHis",
                        err.toString(),
                        "getPrintStatements",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getPrintStatements() {
                let retValue = [];

                try {
                    if (BaseConfiguration.isDebug) console.log("getPrintStatements");

                    let lsAllPostPaidAgents = JSON.parse(
                        JSON.stringify(this.postpaidStmntRes)
                    );
                    let lsPrintStatements = [];
                    if (lsAllPostPaidAgents && lsAllPostPaidAgents.length)
                        lsAllPostPaidAgents.forEach(agent => {
                            agent.list.forEach(statement => {
                                lsPrintStatements = lsPrintStatements.concat(
                                    this.getStatementCurrencies(statement).filter(stmntCurr => {
                                        stmntCurr.agencyName = agent.agencyName;
                                        stmntCurr.b2bCode = agent.b2bCode;
                                        stmntCurr.dueDate = this.$options.filters.formatDateTime(stmntCurr.dueDate);
                                        return this.isSingleAgent ? agent.b2bid == this.agent.b2bid : true;
                                    })
                                );
                            });
                        });

                    retValue = cloneData(lsPrintStatements);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPrintStatements",
                        err.toString(),
                        "getPrintStatements",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            toggleJsonExcelModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toggleJsonExcelModal");

                    this.showJsonExcelModal = !this.showJsonExcelModal;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in toggleJsonExcelModal",
                        err.toString(),
                        "toggleJsonExcelModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            togglePayHisExcelModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("togglePayHisExcelModal");
                    this.showPaymentHisModal = false;

                    this.showPayHisJsonExcelModal = !this.showPayHisJsonExcelModal;
                    if (!this.showPayHisJsonExcelModal) {
                        this.selHisAgent = null;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in togglePayHisExcelModal",
                        err.toString(),
                        "togglePayHisExcelModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            toggleInvoicesExcelModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toggleInvoicesExcelModal");
                    this.showInvoiceModal = false;

                    this.showInvoiceJsonExcelModal = !this.showInvoiceJsonExcelModal;
                    if (!this.showInvoiceJsonExcelModal) {
                        this.selHisAgent = null;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in toggleInvoicesExcelModal",
                        err.toString(),
                        "toggleInvoicesExcelModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            toggleDueDateExcelModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toggleDueDateExcelModal");
                    this.showDueDateHisModal = false;

                    this.showDueDateJsonExcelModal = !this.showDueDateJsonExcelModal;
                    if (!this.showDueDateJsonExcelModal) {
                        this.selHisAgent = null;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in toggleDueDateExcelModal",
                        err.toString(),
                        "toggleDueDateExcelModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            //  togglePostPaidExcelModal() {
            //   try {
            //     if (BaseConfiguration.isDebug) console.log("togglePostPaidExcelModal");


            //     this.showPostPaidJsonExcelModal = !this.showPostPaidJsonExcelModal;

            //   } catch (err) {
            //     let body = Logger.buildRequest(
            //       FILE_NAME.C_SYSTEM_DEPOSIT,
            //       "error in togglePostPaidExcelModal",
            //       err.toString(),
            //       "togglePostPaidExcelModal",
            //       LOG_TYPE.ERROR
            //     );
            //     Logger.getResponse(body);
            //   }
            // },
            getJsonExcelFields() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getJsonExcelFields");
                    let fields = {};
                    fields[this.$t("deposit.agencyName")] = "agencyName";
                    fields[this.$t("deposit.agencyCode")] = "b2bCode";
                    Object.keys(this.getStatementTitles()).forEach(title => {
                        if (title != "action")
                            fields[this.$t(`statementTitle.${title}`)] = title;
                    });

                    retValue = cloneData(fields);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getJsonExcelFields",
                        err.toString(),
                        "getJsonExcelFields",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getExcelFieldsForPayHis() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getExcelFieldsForPayHis");
                    let fields = {};
                    if (this.isTotalDueAmtPopUp) {
                        fields[this.$t("deposit.receivedDate")] = "date";
                        fields[this.$t("deposit.pRef")] = "method";

                        fields[this.$t("deposit.currency")] = "currency";
                        fields[this.$t("deposit.paidAmount")] = "paidamount";
                        fields[this.$t("deposit.dueAmt")] = "pendingamount";

                        fields[this.$t("deposit.paymentBy")] = "username";


                    } else {
                        fields[this.$t("deposit.receivedDate")] = "date";
                        fields[this.$t("deposit.pRef")] = "method";

                        fields[this.$t("deposit.currency")] = "currency";
                        fields[this.$t("deposit.paidAmount")] = "paidamount";
                        fields[this.$t("deposit.paymentBy")] = "username";
                    }


                    retValue = cloneData(fields);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getExcelFieldsForPayHis",
                        err.toString(),
                        "getExcelFieldsForPayHis",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getExcelFieldsForDueDateHis() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getExcelFieldsForDueDateHis");
                    let fields = {};
                    fields[this.$t("deposit.timestamp")] = "ts";
                    fields[this.$t("deposit.changedBy")] = "update_by";

                    fields[this.$t("deposit.oldDate")] = "old_date";

                    fields[this.$t("deposit.newDate")] = "new_date";

                    // fields[this.$t("deposit.extendAt")] = "ts";


                    retValue = cloneData(fields);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getExcelFieldsForDueDateHis",
                        err.toString(),
                        "getExcelFieldsForDueDateHis",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getExcelFieldsForInvoices() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getExcelFieldsForInvoices");
                    let fields = {};

                    fields[this.$t("deposit.orderId")] = "orderid";
                    fields[this.$t("deposit.route")] = "route";
                    fields[this.$t("deposit.journeyType")] = "journeytype";
                    fields[this.$t("deposit.numOfPax")] = "paxcount";

                    fields[this.$t("deposit.passengerName")] = "paxname";

                    fields[this.$t("deposit.transactionType")] = "transactiontype";
                    // fields[this.$t("deposit.transactionNum")] = "transactionid";
                    fields[this.$t("deposit.currency")] = "currencycode";
                    fields[this.$t("deposit.amount")] = "amount";


                    retValue = cloneData(fields);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getExcelFieldsForInvoices",
                        err.toString(),
                        "getExcelFieldsForInvoices",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            selectPrintStatements(pStatementNo) {
                try {
                    if (BaseConfiguration.isDebug) console.log("selectPrintStatements");

                    if (pStatementNo) {
                        if (this.lsPrintableStatements.includes(pStatementNo)) {
                            this.lsPrintableStatements = cloneData(
                                this.lsPrintableStatements.filter((stmntNo, index) => {
                                    return stmntNo != pStatementNo;
                                })
                            );
                        } else {
                            this.lsPrintableStatements.push(pStatementNo);
                        }
                    } else {
                        throw "invalid Statement No.";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in selectPrintStatements",
                        err.toString(),
                        "selectPrintStatements",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onPaymentCurrencyChange(pCurrency) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onPaymentCurrencyChange");

                    if (pCurrency) {
                        this.resetPaymentDet();
                        this.lsDepositCurrencies = this.getDepositCurrencies(
                            this.lsPaymentStatements
                        );
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in onPaymentCurrencyChange",
                        err.toString(),
                        "onPaymentCurrencyChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            resetPaymentDet() {
                try {
                    if (BaseConfiguration.isDebug) console.log("resetPaymentDet");

                    this.paymentDet.newAmount = null;
                    this.paymentDet.method = null;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in resetPaymentDet",
                        err.toString(),
                        "resetPaymentDet",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            assigni18nObjByLang(pCurrDueDate) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

                    retValue = {
                        night: this.$t("flightDatePicker.night"),
                        nights: this.$t("flightDatePicker.nights"),
                        "day-names": [
                            this.$t("flightDatePicker.sun"),
                            this.$t("flightDatePicker.mon"),
                            this.$t("flightDatePicker.tue"),
                            this.$t("flightDatePicker.wed"),
                            this.$t("flightDatePicker.thur"),
                            this.$t("flightDatePicker.fri"),
                            this.$t("flightDatePicker.sat")
                        ],
                        "check-in": pCurrDueDate ? formatDate(pCurrDueDate,DATE_TIME_FORMAT.DEFAULT_DATE_FORMAT) : this.$t("flightDatePicker.checkIn"),
                        "check-out": this.$t("flightDatePicker.checkOut"),
                        "month-names": [
                            this.$t("flightDatePicker.jan"),
                            this.$t("flightDatePicker.feb"),
                            this.$t("flightDatePicker.mar"),
                            this.$t("flightDatePicker.apr"),
                            this.$t("flightDatePicker.may"),
                            this.$t("flightDatePicker.jun"),
                            this.$t("flightDatePicker.july"),
                            this.$t("flightDatePicker.aug"),
                            this.$t("flightDatePicker.sep"),
                            this.$t("flightDatePicker.oct"),
                            this.$t("flightDatePicker.nov"),
                            this.$t("flightDatePicker.dec")
                        ]
                    };
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in assigni18nObjByLang",
                        err.toString(),
                        "assigni18nObjByLang",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            //for custom search
            agencyNameWithCode(option) {
                return `${option.agencyName}  (${option.b2bCode})`;
            },

            togglePaymentTransModal(pName) {
                try {
                    if (BaseConfiguration.isDebug) console.log("togglePaymentTransModal");
                    this.showPaymentTransModal = !this.showPaymentTransModal;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in togglePaymentTransModal",
                        err.toString(),
                        "togglePaymentTransModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            async getPaymentTransactions(pStmntId, pB2BId) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getPaymentTransactions");
                    if (pStmntId && pB2BId) {
                        let paymentTransReq = apiPostPaidTransactions.buildRequest(
                            pStmntId,
                            pB2BId
                        );

                        if (paymentTransReq) {
                            let paymentTransRes = await apiPostPaidTransactions.getResponse(
                                paymentTransReq
                            );
                            if (VALIDATE_SUCCESS_RES(paymentTransRes)) {
                                this.alertValue = null;
                                this.lsPaymentTransactions = paymentTransRes.data.data;

                                this.togglePaymentTransModal();
                            } else {
                                let error = getErrorMessage(paymentTransRes);

                                let isJwt = handleJWT(error);
                                if (!isJwt) {
                                    this.alertValue = getErrorAlertValue(error);
                                }
                            }
                        } else {
                            throw "invalid  postpaid payment transaction   request";
                        }
                    } else {
                        throw "invalid request data";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPaymentTransactions",
                        err.toString(),
                        "getPaymentTransactions",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            togglePaymentHisModal(pName) {
                try {
                    if (BaseConfiguration.isDebug) console.log("togglePaymentHisModal");
                    this.showPaymentHisModal = !this.showPaymentHisModal;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in togglePaymentHisModal",
                        err.toString(),
                        "togglePaymentHisModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            async getPaymentHisForExtendDueDate(pStmntId) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getPaymentHisForExtendDueDate");
                    if (pStmntId) {
                        let paymentHisReq = apiGetExtendDueDateHistory.buildRequest(
                            pStmntId
                        );

                        if (paymentHisReq) {
                            let paymentHisRes = await apiGetExtendDueDateHistory.getResponse(
                                paymentHisReq
                            );
                            if (VALIDATE_SUCCESS_RES(paymentHisRes)) {
                                this.alertValue = null;

                                this.lsDueDateHistory = paymentHisRes.data.data.ExtendDueDateHistory;


                            } else {
                                let error = getErrorMessage(paymentHisRes);

                                let isJwt = handleJWT(error);
                                if (!isJwt) {
                                    this.alertValue = getErrorAlertValue(error);
                                }
                            }
                        } else {
                            throw "invalid  postpaid payment history   request";
                        }
                    } else {
                        throw "invalid request data";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPaymentHisForExtendDueDate",
                        err.toString(),
                        "getPaymentHisForExtendDueDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            async getPaymentHistory(pStmntId, pB2BId, pAgent) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getPaymentHistory");
                    this.selHisAgent = pAgent;
                    if (pStmntId && pB2BId) {
                        let paymentHisReq = apiPostPaidPaymentHistory.buildRequest(
                            pStmntId,
                            pB2BId
                        );

                        if (paymentHisReq) {
                            let paymentHisRes = await apiPostPaidPaymentHistory.getResponse(
                                paymentHisReq
                            );
                            if (VALIDATE_SUCCESS_RES(paymentHisRes)) {
                                this.alertValue = null;

                                this.lsPaymentHis = paymentHisRes.data.data;

                                this.togglePaymentHisModal();
                            } else {
                                let error = getErrorMessage(paymentHisRes);

                                let isJwt = handleJWT(error);
                                if (!isJwt) {
                                    this.alertValue = getErrorAlertValue(error);
                                }
                            }
                        } else {
                            throw "invalid  postpaid payment history   request";
                        }
                    } else {
                        throw "invalid request data";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPaymentHistory",
                        err.toString(),
                        "getPaymentHistory",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            sortStatements() {
                try {
                    if (BaseConfiguration.isDebug) console.log("sortStatements");

                    this.isAscSort = !this.isAscSort;
                    if (this.isSingleAgent) {
                        if(this.agent&&this.agent.list){
                          this.agent.list = OrderByList(
                            this.agent.list,
                            "toDate",
                            this.isAscSort ? "asc" : "desc"
                        );
                        }
                       
                    } else {
                        var _ = require('lodash');

                        this.lsPostpaidStatements = OrderByList(
                            this.lsPostpaidStatements,
                            this.getPropToSortStatements,
                            this.isAscSort ? "asc" : "desc"
                        );
                    }


                    //       this.lsPostpaidStatements.map(agent =>
                    // _.orderBy(agent.list, ['toDate'], [this.isAscSort ? "asc" : "desc"])

                    // this.lsPostpaidStatements.forEach(agent => {
                    //   agent.list = OrderByList(
                    //     agent.list,
                    //     "toDate",
                    //     this.isAscSort ? "asc" : "desc"
                    //   );
                    // });

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in sortStatements",
                        err.toString(),
                        "sortStatements",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            getPropToSortStatements(pStatement) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getPropToSortStatements");
                    if (pStatement&&pStatement.list[0]) {
                        return pStatement.list[0].toDate;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPropToSortStatements",
                        err.toString(),
                        "getPropToSortStatements",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },


            clearPaymentStatements() {
                try {
                    if (BaseConfiguration.isDebug) console.log("clearPaymentStatements");

                    this.lsPaymentStatements = [];
                    this.lsDepositCurrencies = [];
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in clearPaymentStatements",
                        err.toString(),
                        "clearPaymentStatements",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            setDepositAmount(value) {
                try {
                    if (BaseConfiguration.isDebug) console.log("setDepositAmount");
                    updateDataEdited(true);
                    this.paymentDet.newAmount = value;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in setDepositAmount",
                        err.toString(),
                        "setDepositAmount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            async extendDueDate() {
                try {
                    if (BaseConfiguration.isDebug) console.log("extendDueDate");

                    let b2bId = this.agent ? this.agent.b2bid : null;
                    if (
                        this.stmntExtendDet &&
                        this.stmntExtendDet.lsStmnts &&
                        b2bId &&
                        this.stmntExtendDet.newDueDate
                    ) {
                        let extendDueDateReq = apiPostPaidExtendDueDate.buildRequest(
                            this.stmntExtendDet.lsStmnts,
                            this.$options.filters.formatDate(
                                this.stmntExtendDet.newDueDate,
                                DATE_TIME_FORMAT.API_DATE_FORMAT
                            ),

                            b2bId
                        );

                        if (extendDueDateReq) {
                            let extendDueDateRes = await apiPostPaidExtendDueDate.getResponse(
                                extendDueDateReq
                            );
                            if (VALIDATE_SUCCESS_RES(extendDueDateRes)) {
                                this.stmntExtendDet.currDueDate = this.stmntExtendDet.newDueDate;
                                this.alertValue = null;

                                await this.onReportDataChange();
                                this.toggleConfirmModal();
                                this.isDateExtended=true;
                               


                            } else {
                                let error = getErrorMessage(extendDueDateRes);

                                let isJwt = handleJWT(error);
                                if (!isJwt) {
                                    this.alertValue = getErrorAlertValue(error);
                                }
                            }
                        } else {
                            throw "invalid  extend due date   request";
                        }
                    } else {
                        throw "invalid request data";
                    }
                    updateDataEdited(false);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in extendDueDate",
                        err.toString(),
                        "extendDueDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            setNewDueDate(pDate) {
                try {
                    if (BaseConfiguration.isDebug) console.log("setNewDueDate");
                    if (pDate) {
                        this.stmntExtendDet.newDueDate = pDate;
                    }
                    updateDataEdited(true);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in setNewDueDate",
                        err.toString(),
                        "setNewDueDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            onPay(pAgent, pStatement) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onPay");

                    this.clearAllFilters();


                    this.clearPaymentStatements();
                    if (pAgent && pAgent.list && pAgent.list.length) {
                        this.agent = this.getAgentDetails(pAgent);
                        this.isSingleAgent = true;

                           this.resetNewDueAmount();

                        let statementNo = null;
                        let statement = null;

                        this.getStatementCurrencies(pStatement).forEach((curr, index) => {
                            if ((statementNo == null) && curr.statementNo) {
                                statementNo = curr.statementNo;
                                statement=curr;
                                //break;
                            }
                        });
                        if (statementNo != null)
                            this.selectPaymentStatements(statementNo,statement);
                    }
                    /*    this.stmntExtendDet.lsStmnts = [];
                        this.stmntExtendDet.currDueDate = null;

                        this.getStatementCurrencies(pStatement).forEach((curr, index) => {
                            if (!index) {
                                this.stmntExtendDet.currDueDate = new Date(curr.dueDate);
                                this.stmntExtendDet.newDueDate = addDays(this.stmntExtendDet.currDueDate, 7);
                            }
                            this.stmntExtendDet.lsStmnts.push(curr.statementNo);
                        });

                        if (
                            this.stmntExtendDet.lsStmnts &&
                            this.stmntExtendDet.lsStmnts.length
                        ) {
                            this.stmntExtendDet.lsStmntsCurrencies = this.getDepositCurrencies(
                                this.stmntExtendDet.lsStmnts
                            );
                        }
                    }*/
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in onExtendDueDate",
                        err.toString(),
                        "onExtendDueDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            onExtendDueDate(pAgent, pStatement) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onExtendDueDate");
                    this.selAgentObj = pAgent;
                    this.clearAllFilters();

                    this.showExtendDueDateModal = true;
                    this.clearPaymentStatements();
                    if (pAgent && pAgent.list && pAgent.list.length) {
                        this.agent = this.getAgentDetails(pAgent);
                        this.isSingleAgent = true;
                        this.stmntExtendDet.lsStmnts = [];
                        this.stmntExtendDet.currDueDate = null;
                        this.resetNewDueAmount();

                        this.getStatementCurrencies(pStatement).forEach((curr, index) => {
                            if (!index) {
                                this.stmntExtendDet.currDueDate = new Date(curr.dueDate);
                                this.stmntExtendDet.canExtendDays = curr.canExtendDays;
                                ///to assign new due date-start
                                let startDateValue=this.getExtendStartDateValue(this.stmntExtendDet.currDueDate);
                                let endDateValue=this.getExtendEndDateValue(this.stmntExtendDet);
                                if (curr.canExtendDays && curr.canExtendDays >= 7) {
                                    this.stmntExtendDet.newDueDate = addDays(startDateValue, 7);

                                } else {
                                    this.stmntExtendDet.newDueDate = addDays(startDateValue, curr.canExtendDays==0?0:curr.canExtendDays-1);

                                }
                                ///to assign new due date-end
                            }
                            this.stmntExtendDet.lsStmnts.push(curr.statementNo);
                        });

                        if (
                            this.stmntExtendDet.lsStmnts &&
                            this.stmntExtendDet.lsStmnts.length
                        ) {
                            this.stmntExtendDet.lsStmntsCurrencies = this.getDepositCurrencies(
                                this.stmntExtendDet.lsStmnts
                            );
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in onExtendDueDate",
                        err.toString(),
                        "onExtendDueDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            payStatementFromAll(pAgent, pStatementNo,pStatement) {
                try {
                    if (BaseConfiguration.isDebug) console.log("payStatementFromAll");
                    this.agent = pAgent;
                    this.showExtendDueDateModal = false;

                    this.isSingleAgent = true;
                    this.selectPaymentStatements(pStatementNo,pStatement);
                   this. resetNewDueAmount();
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in payStatementFromAll",
                        err.toString(),
                        "payStatementFromAll",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getModalDesc() {
                let retValue = "";
                try {
                    if (BaseConfiguration.isDebug) console.log("getModalDesc");
                    if (this.lsPaymentStatements && this.lsPaymentStatements.length) {
                        retValue = this.$t("deposit.modalDesc", {
                            curr: this.paymentCurrency.currency_code.code,
                            amount: 
                                this.paymentDet.newAmount?this.paymentDet.newAmount:this.paymentDet.payableAmount,
                               
                            
                            agencyName: this.agent.agencyName,
                            agtCode: this.agent.b2bCode
                        });
                    } else {
                        retValue = this.$t("deposit.modalDescSucc", {
                            date: this.$options.filters.formatDate(this.stmntExtendDet.newDueDate, )
                        });
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getModalDesc",
                        err.toString(),
                        "getModalDesc",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getStatementTitles(isSelect) {
                let retValue = {};
                try {
                    if (BaseConfiguration.isDebug) console.log("getStatementTitles");
                    retValue = {
                        statementNo: "Statement No.",
                        invoice: "InVoice",
                        dueDate: "Statement Due Date",
                        name: "Currency",
                        dueAmount: "Total Outstanding",
                        paidAmount: "Paid Amount",
                        balanceDue: "Balance Due",
                        //   select: "Select",
                        action: "Action"
                    };

                    /*  if(!isSelect)
         {
           delete retValue.select

         } */


                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getStatementTitles",
                        err.toString(),
                        "getStatementTitles",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            toggleConfirmModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toggleConfirmModal");
                    if (this.isDepositSuccess || this.isDepositFailed||this.isDateExtended) {
                        this.isDepositSuccess = false;
                        this.isDepositFailed = false;
                        if(this.isDateExtended){
                             navigate(PATHNAME.VIEW_STATEMENTS)
                            this.isDateExtended=false;
                        }
                        
                    } else {
                        this.showConfirmModal = !this.showConfirmModal;
                    }


                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in toggleConfirmModal",
                        err.toString(),
                        "toggleConfirmModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getModalButtons() {
                let retValue = [];

                try {
                    if (BaseConfiguration.isDebug) console.log("getModalButtons");
                    if (this.lsPaymentStatements && this.lsPaymentStatements.length)
                        retValue = [
                            {
                                name: this.$t("deposit.no"),
                                func: this.toggleConfirmModal
                            },
                            {
                                name: this.$t("deposit.yes"),
                                func: this.depositDueAmount
                            }
                        ];
                    else {
                        retValue = [
                            {
                                name: this.$t("deposit.cancel"),
                                func: this.toggleConfirmModal
                            },
                            {
                                name: this.$t("deposit.extendDueDate"),
                                func: this.extendDueDate
                            }
                        ];
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getModalButtons",
                        err.toString(),
                        "getModalButtons",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getPostPaidDepositRequest() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getPostPaidDepositRequest");
                    let depositReq = {};


                 

                    depositReq.b2bId =
                        this.agent && this.agent.b2bid ? this.agent.b2bid : null;
                    depositReq.statementsId = this.lsPaymentStatements;

                    depositReq.totalAmount = this.paymentDet.newAmount
                        ? this.paymentDet.newAmount
                        : this.paymentDet.payableAmount;
                    depositReq.receivedDate = this.paymentDet.recievedDate
                        ? this.$options.filters.formatDate(
                            this.paymentDet.recievedDate,
                            DATE_TIME_FORMAT.API_DATE_FORMAT
                        )
                        : null;

                    depositReq.paymentMethod = this.paymentDet.method;
                    depositReq.paymentCurrency =
                        this.paymentCurrency &&
                        this.paymentCurrency.currency_code &&
                        this.paymentCurrency.currency_code.code
                            ? this.paymentCurrency.currency_code.code
                            : null;

                    /* currency: curr,
              balAmount: balanceAmount,
              sysExRate: sysExRate,
              newExRate: 0 */
                    depositReq.exchangeRate = [];
                    this.lsDepositCurrencies.forEach(depCurr => {
                        depositReq.exchangeRate.push({
                            currency: depCurr.currency,
                            rate: depCurr.newExRate ? depCurr.newExRate : depCurr.sysExRate
                        });
                    });

                    retValue = cloneData(depositReq);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPostPaidDepositRequest",
                        err.toString(),
                        "getPostPaidDepositRequest",
                        LOG_TYPE.ERROR
                     );
                    Logger.getResponse(body);
                }
                return retValue;
            },


       async  onDepositSuccess() {
             try {
               if(BaseConfiguration.isDebug) console.log("onDepositSuccess");
               this.onHideSuccDeposit()

                await  this.onReportDataChange()


               

            
         
             } catch (err) {
                     let body = Logger.buildRequest(
                       FILE_NAME.C_SYSTEM_DEPOSIT,
                       "error in onDepositSuccess",
                       err.toString(),
                       "onDepositSuccess",
                       LOG_TYPE.ERROR
                     );
                     Logger.getResponse(body);
                   }
             
             }, 

 




            async depositDueAmount() {
                try {
                    if (BaseConfiguration.isDebug) console.log("depositDueAmount");
                        this.showConfirmModal = false;


                    let depositReq = apiPostPaidDeposit.buildRequest(
                        this.getPostPaidDepositRequest()
                    );


                    if (depositReq) {

                        let depositRes = await apiPostPaidDeposit.getResponse(depositReq);
                        if (VALIDATE_SUCCESS_RES(depositRes)) {
                            this.alertValue = null;
                                   this.isDepositSuccess = true;
                        //    await this.onReportDataChange();

                      
                        } else {
                            let error = getErrorMessage(depositRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error, true, true);
                                if (this.alertValue) {

                                    this.isDepositFailed = true;

                                }
                            }
                        }
                    } else {
                        throw "invalid deposit  request";
                    }
                    updateDataEdited(false);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in depositDueAmount",
                        err.toString(),
                        "depositDueAmount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },


            getTotalDepsoitAmount(pDepsoitCurrenciesList) {
                let retValue = 0;
                try {
                    if (BaseConfiguration.isDebug) console.log("getTotalDepsoitAmount");

                    if (pDepsoitCurrenciesList && pDepsoitCurrenciesList.length) {
                        pDepsoitCurrenciesList.forEach(deposit => {
                            retValue += this.getDepositConvertedAmount(deposit);
                        });
                    }

                    if (this.paymentDet) {
                        this.paymentDet.payableAmount = retValue;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getTotalDepsoitAmount",
                        err.toString(),
                        "getTotalDepsoitAmount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            setPaymentDate(pDate) {
                try {
                    if (BaseConfiguration.isDebug) console.log("setPaymentDate");

                    if (pDate) {
                        this.paymentDet.recievedDate = pDate;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in setPaymentDate",
                        err.toString(),
                        "setPaymentDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            setReportToDate(pDate) {
                try {
                    if (BaseConfiguration.isDebug) console.log("setReportToDate");

                    if (pDate) {
                        this.postpaidStatement.toDate = pDate;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in setReportToDate",
                        err.toString(),
                        "setReportToDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            setReportFromDate(pDate) {
                try {
                    if (BaseConfiguration.isDebug) console.log("setReportFromDate");

                    if (pDate) {
                        this.postpaidStatement.fromDate = pDate;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in setReportFromDate",
                        err.toString(),
                        "setReportFromDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getAgentDetails(pAgent) {
                let returnValue = {};
                try {
                    if (BaseConfiguration.isDebug) console.log("getAgentDetails");

                    if (pAgent && pAgent.b2bid && this.postpaidStmntRes) {
                        let agentObj = this.postpaidStmntRes.find(
                            agt => agt.b2bid == pAgent.b2bid
                        );

                        if (agentObj) {
                            pAgent = agentObj;
                        } else {
                            pAgent.list = [];
                        }
                    }

                    returnValue = pAgent;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getAgentDetails",
                        err.toString(),
                        "getAgentDetails",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },

            async onReportDataChange() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onReportDataChange");
            
                    let b2bId = this.agent ? this.agent.b2bid : null;
                    let fromDate = this.postpaidStatement.fromDate
                        ? this.postpaidStatement.fromDate
                        : null;
                    let toDate = this.postpaidStatement.toDate
                        ? this.postpaidStatement.toDate
                        : null;

                    let status = this.isViewOnly ? POSTPAID_STATEMENT_STATUS.ALL : POSTPAID_STATEMENT_STATUS.DEPOSIT;

                    this.lsPostpaidStatements = await this.getPostPaidStatements(
                        null,
                        fromDate,
                        toDate,
                        status
                    );
                //      this.lsPostpaidStatements = OrderByList(this.lsPostpaidStatements, this.getPropToSortAgents, ORDER.ASC);
                      
                
                    this.agent = this.getAgentDetails(this.agent);
                      this.   resetNewDueAmount();
                    let selAgent=cloneDeep(this.agent);
                     this.lsAllPostPaidAgents = this.getAllPostPaidAgents(
                    cloneData(this.lsPostpaidStatements)
                );
                if(this.isSingleAgent){
                 this.agent=this.getSelAgentFromRes(selAgent,this.lsAllPostPaidAgents);
                 this.selAgentObj=this.agent;
                }else{
                 this.lsStatementNo = this.getStatementNoOptionLs();
                
                }
                if(this.selStatement){
              this.onFilterByStatementNo();
                }
                                       

                                         

                
                // this.agent =selAgent;
                    this.clearAllFilters();
                    this.clearPaymentStatements();

                    this.isShowStatementDp=false;
                    let that = this;
                         Vue.nextTick(function () {
                            that.isShowStatementDp = true;
                        });
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in onReportDataChange",
                        err.toString(),
                        "onReportDataChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            checkAndAssignStatementNo(pSelStatement,pLsStatementNo) {
                let retValue=null;
                try {
                  if(BaseConfiguration.isDebug) console.log("checkAndAssignStatementNo");
                  for(let i=0;i<pLsStatementNo.length;i++){
                      if(pLsStatementNo[i].statementNo==pSelStatement.statementNo){
                          retValue=pLsStatementNo[i];
                      }
                  }
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_SYSTEM_DEPOSIT,
                          "error in checkAndAssignStatementNo",
                          err.toString(),
                          "checkAndAssignStatementNo",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
                }, 
            getSelAgentFromRes(pAgent,pLsAllPostPaidAgents) {
                let retValue=null;
                try {
                  if(BaseConfiguration.isDebug) console.log("getSelAgentFromRes");
                  if(pAgent){
              for(let i=0;i<pLsAllPostPaidAgents.length;i++){
                      if(pLsAllPostPaidAgents[i].b2bid==pAgent.b2bid){
                          retValue=pLsAllPostPaidAgents[i];
                          break;
                      }
                  }
                  }
                  
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_SYSTEM_DEPOSIT,
                          "error in getSelAgentFromRes",
                          err.toString(),
                          "getSelAgentFromRes",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
                }, 

            getDepositConvertedAmount(pDeposit) {
                let retValue = 0;
                try {
                    if (BaseConfiguration.isDebug) console.log("getDepositConvertedAmount");
                    if (pDeposit) {
                        if (pDeposit.newExRate && pDeposit.newExRate > 0) {
                            retValue =
                                parseFloat(pDeposit.balAmount) * parseFloat(pDeposit.newExRate);
                        } else if (pDeposit.sysExRate && pDeposit.sysExRate > 0) {
                            retValue =
                                parseFloat(pDeposit.balAmount) * parseFloat(pDeposit.sysExRate);
                        } else {
                            retValue = parseFloat(pDeposit.balAmount);
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getDepositConvertedAmount",
                        err.toString(),
                        "getDepositConvertedAmount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            selectAllPaymentStatements(pStatementList) {
                try {
                    if (BaseConfiguration.isDebug)
                        if (BaseConfiguration.isDebug) console.log("selectAllPaymentStatements");
                    this.showExtendDueDateModal = false

                    if (pStatementList && pStatementList.length) {
                        this.lsPaymentStatements = [];
                        pStatementList.forEach(statement => {
                            this.getStatementCurrencies(statement).forEach(stmntCurr => {
                                if (
                                    stmntCurr &&
                                    stmntCurr.statementNo &&
                                    stmntCurr.statementStatus != POSTPAID_STATEMENT_STATUS.PAID &&
                                    stmntCurr.statementStatus != POSTPAID_STATEMENT_STATUS.EMPTY
                                )
                                    this.selectPaymentStatements(stmntCurr.statementNo,stmntCurr);
                            });
                        });
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in selectAllPaymentStatements",
                        err.toString(),
                        "selectAllPaymentStatements",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            groupDepositCurrencies(pDepositCurrenciesList) {
                let retValue = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("groupDepositCurrencies");
                    pDepositCurrenciesList = cloneData(pDepositCurrenciesList);
                    let lsDepositCurrencies = [];
                    if (pDepositCurrenciesList && pDepositCurrenciesList.length) {
                        let lsCurrencies = [];
                        pDepositCurrenciesList.map(curr => {
                            if (!lsCurrencies.includes(curr.name)) {
                                lsCurrencies.push(curr.name);
                                return curr.name;
                            }
                        });

                        this.lsSystemExchangeRate;
                        lsCurrencies.forEach(curr => {
                            let balanceAmount = 0;
                            let sysExRate = 0;

                            if (
                                this.lsSystemExchangeRate &&
                                this.lsSystemExchangeRate.length &&
                                this.paymentCurrency &&
                                this.paymentCurrency.currency_code
                            ) {
                                let exRateObj = (sysExRate = this.lsSystemExchangeRate.find(
                                    exRate => {
                                        return (
                                            exRate.from_currency == curr &&
                                            exRate.to_currency ==
                                            this.paymentCurrency.currency_code.code
                                        );
                                    }
                                ));

                                if (exRateObj) {
                                    sysExRate = exRateObj.exrate;
                                } else {
                                    sysExRate = 1;
                                }
                            }

                            pDepositCurrenciesList.forEach(depCurr => {

                               
                                if (curr == depCurr.name)
                                    balanceAmount += parseFloat(depCurr.balanceDue);
                            });

                            lsDepositCurrencies.push({
                                currency: curr,
                                balAmount: balanceAmount,
                                sysExRate: sysExRate,
                                newExRate: sysExRate
                            });
                        });

                        retValue = lsDepositCurrencies;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in groupDepositCurrencies",
                        err.toString(),
                        "groupDepositCurrencies",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getDepositCurrencies(lsPaymentStatements) {
                let retValue = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("getDepositCurrencies");

                    if (this.agent && this.agent.list && this.agent.list.length) {
                        this.agent.list.forEach(statement => {
                            retValue = retValue.concat(
                                this.getStatementCurrencies(statement).filter(stmntCurr => {

                                    if(!this.showExtendDueDateModal && stmntCurr && stmntCurr.newBalAmount!=null && parseFloat(stmntCurr.newBalAmount)>=0 && parseFloat(stmntCurr.balanceDue)>= parseFloat(stmntCurr.newBalAmount))
                                    {
                                        stmntCurr.balanceDue =stmntCurr.newBalAmount;
                                    }
                                     else if ( !this.showExtendDueDateModal && stmntCurr &&  stmntCurr.newBalAmount!=null && stmntCurr.newBalAmount.toString().length==0 || parseFloat(stmntCurr.newBalAmount)==0 || isNaN(stmntCurr.newBalAmount)) 
                                     {
                                         stmntCurr.balanceDue=0;
                                     }

                                    return lsPaymentStatements.includes(stmntCurr.statementNo);
                                })
                            );
                        });
                    }
                    retValue = cloneData(this.groupDepositCurrencies(retValue));
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getDepositCurrencies",
                        err.toString(),
                        "getDepositCurrencies",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            assignSelCurrForDefSelection(pLsDepositCurrency) {
                try {
                  if(BaseConfiguration.isDebug) console.log("assignSelCurrForDefSelection");
                  if(pLsDepositCurrency&&pLsDepositCurrency.constructor==Array&&pLsDepositCurrency[0]){
                      this.selCurrencyCode=pLsDepositCurrency[0].currency;
                  }else if(pLsDepositCurrency&&pLsDepositCurrency.currency){
                   this.selCurrencyCode=pLsDepositCurrency.currency;

                  }
                  this.paymentCurrency=null
                  this.isOrgCurrencyDpShow=false;
                  let that = this;

        Vue.nextTick(function() {
          that.isOrgCurrencyDpShow = true;
        });
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_SYSTEM_DEPOSIT,
                          "error in assignSelCurrForDefSelection",
                          err.toString(),
                          "assignSelCurrForDefSelection",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                 
                }, 

            selectPaymentStatements(pStatementNo,pStatement) {
                try {
                    if (BaseConfiguration.isDebug) console.log("selectPaymentStatements");
                    if (pStatementNo) {
                        if (this.lsPaymentStatements.includes(pStatementNo)) {
                            this.lsPaymentStatements = cloneData(
                                this.lsPaymentStatements.filter((stmntNo, index) => {
                                    return stmntNo != pStatementNo;
                                })
                            );
                        } else {
                            this.lsPaymentStatements.push(pStatementNo);
                            this.showExtendDueDateModal = false;
                        }
                    } else {
                        throw "invalid Statement No.";
                    }
                   this.resetPaymentDet();
                    this.lsDepositCurrencies = this.getDepositCurrencies(
                        this.lsPaymentStatements
                    );
                    this.assignSelCurrForDefSelection(this.lsDepositCurrencies);

                   
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in selectPaymentStatements",
                        err.toString(),
                        "selectPaymentStatements",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            async getAllExchngRate() {
                if (BaseConfiguration.isDebug) console.log("getAllExchngRate");

                let retValue = [];

                try {
                    let createExchngRequest = apiExchangeRateDetails.buildRequest();

                    if (createExchngRequest != null) {
                        let createExchngResponse = await apiExchangeRateDetails.getResponse(
                            createExchngRequest
                        );
                        if (VALIDATE_SUCCESS_RES(createExchngResponse)) {
                            retValue = createExchngResponse.data.data;

                            this.alertValue = null;
                        } else {
                            let error = getErrorMessage(createExchngResponse);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in  getting Exchange Response",
                        err.toString(),
                        "getAllExchngRate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getOutstanding(pDueDate,pStmntCurr) {

                try {
                  if(BaseConfiguration.isDebug) console.log("getOutstanding");
                  if(pStmntCurr.statementStatus != POSTPAID_STATEMENT_STATUS.EMPTY){

                  
                   if (getDiffBtwDates(
                            new Date(pDueDate),
                            new Date(),
                            "days"
                        ) > 0) {
                            return false;
                        } else if (getDiffBtwDates(
                            new Date(pDueDate),
                            new Date(),
                            "days"
                        ) == 0 && formatDate(pDueDate, 'DD') == formatDate(Date(), 'DD')) {
                            return false;
                        } else {
                            return true;
                        }
                  }else{
                      return false;
                  }
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.C_SYSTEM_DEPOSIT,
                          "error in getOutstanding",
                          err.toString(),
                          "getOutstanding",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                }, 

            filterPostpaidStatements(pPostPaidObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("filterPostpaidStatements");
                    this.selStatement = null;
                    // this.postpaid.isPastDueDate = false;
                    if (this.postpaidStmntRes && this.postpaidStmntRes.length) {
                        let lsAllPostpaidStatements = JSON.parse(
                            JSON.stringify(this.postpaidStmntRes)
                        );

                        if (pPostPaidObj && pPostPaidObj.type) {
                            lsAllPostpaidStatements = lsAllPostpaidStatements.filter(agent => {
                                if (agent && agent.postpaidType != null)
                                    return agent.postpaidType == pPostPaidObj.type.value;
                            });
                        }

                        if (lsAllPostpaidStatements && lsAllPostpaidStatements.length) {
                            lsAllPostpaidStatements.forEach(agent => {
                                if (agent && agent.list && agent.list.length)
                                    agent.list = agent.list.filter(statement => {
                                        if (pPostPaidObj) {
                                            let retValue = this.getStatementCurrencies(
                                                statement
                                            ).filter(stmntCurr => {
                                                let returnStmnt;
                                                if(pPostPaidObj.isPastDueDate&&!pPostPaidObj.isPaid&&(this.getOverDueClass(stmntCurr.dueDate,stmntCurr))){
                                                 returnStmnt = true;
                                                }
                                                else if(pPostPaidObj.isPastDueDate&&pPostPaidObj.isPaid && (stmntCurr.statementStatus== POSTPAID_STATEMENT_STATUS.PAID||this.getOutstanding(stmntCurr.dueDate,stmntCurr))){
                                                 returnStmnt = true;
                                                }
                                                else if (!pPostPaidObj.isPastDueDate&&!pPostPaidObj.isPaid && !pPostPaidObj.isDueBalance) {
                                                    returnStmnt = true;
                                                } else if (
                                                    !pPostPaidObj.isPastDueDate&&pPostPaidObj.isPaid &&
                                                    pPostPaidObj.isDueBalance &&
                                                    (stmntCurr.statementStatus ==
                                                        POSTPAID_STATEMENT_STATUS.PAID ||
                                                        stmntCurr.statementStatus ==
                                                        POSTPAID_STATEMENT_STATUS.PARTIALLY_PAID ||
                                                        stmntCurr.statementStatus ==
                                                        POSTPAID_STATEMENT_STATUS.NEW)
                                                ) {
                                                    return true;
                                                } else if (
                                                   !pPostPaidObj.isPastDueDate&& pPostPaidObj.isPaid &&
                                                    (stmntCurr.statementStatus ==
                                                    POSTPAID_STATEMENT_STATUS.PAID||stmntCurr.statementStatus==POSTPAID_STATEMENT_STATUS.EMPTY)
                                                ) {
                                                    returnStmnt = true;
                                                } else if (
                                                  !pPostPaidObj.isPastDueDate&&  pPostPaidObj.isDueBalance &&
                                                    (stmntCurr.statementStatus ==
                                                        POSTPAID_STATEMENT_STATUS.PARTIALLY_PAID ||
                                                        stmntCurr.statementStatus ==
                                                        POSTPAID_STATEMENT_STATUS.NEW)
                                                ) {
                                                    returnStmnt = true;
                                                } else {
                                                    returnStmnt = false;
                                                }

                                                return returnStmnt;
                                            });

                                            if (retValue && retValue.length) {
                                                let lsCurrencies = retValue.map(curr => curr.statementNo);

                                                Object.keys(statement).forEach(key => {
                                                    if (
                                                        !lsCurrencies.includes(statement[key].statementNo) &&
                                                        key != "fromDate" &&
                                                        key != "toDate"
                                                    ) {
                                                        delete statement[key];
                                                    }
                                                });

                                                return true;
                                            }
                                        } else {
                                            return false;
                                        }
                                    });
                            });
                        }

                        this.lsPostpaidStatements = cloneData(lsAllPostpaidStatements);
                        let count = 0;
                        for (let i = 0; i < this.lsPostpaidStatements.length; i++) {
                            count = count + this.lsPostpaidStatements[i].list.length;
                        }
                        this.cSystemDepositWatchList.filteredlistCount = count;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in filterPostpaidStatements",
                        err.toString(),
                        "filterPostpaidStatements",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getPostPaidTypes() {
                let retValue = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("getPostPaidTypes");

                    retValue = [
                        {
                            name: this.$t("deposit.monthly"),
                            value: POSTPAID_TYPE.MONTHLY
                        },
                        {
                            name: this.$t("deposit.weekly"),
                            value: POSTPAID_TYPE.WEEKLY
                        },
                        {
                            name: this.$t("deposit.twiceAWeek"),
                            value: POSTPAID_TYPE.ONCE_A_WEEK
                        }
                    ];
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPostPaidTypes",
                        err.toString(),
                        "getPostPaidTypes",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getInitialReportDate() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getInitialReportDate");

                    retValue = subMonths(
                        new Date(),
                        BaseConfiguration.defaultPostPaidReportDur
                    );
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getInitialReportDate",
                        err.toString(),
                        "getInitialReportDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            clearAllFilters() {
                try {
                    if (BaseConfiguration.isDebug) console.log("clearAllFilters");

                    (this.postpaid.type = null),
                        (this.postpaid.isPaid = false),
                        (this.postpaid.isDueBalance = false);
                        this.postpaid.isPastDueDate=false;
                    this.alertValue = null;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in clearAllFilters",
                        err.toString(),
                        "clearAllFilters",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onAllAgentChange(pAgent) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onAllAgentChange");
                    this.SET_OVER_DUE_FILTER(false);
                    this.selStatement = null;
                    this.isShowStatementDp=false;
                    let that = this;
                         Vue.nextTick(function () {
                            that.isShowStatementDp = true;
                        });
                    this.clearAllFilters();
// this.selAgentObj = cloneDeep(pAgent);
                    if (pAgent && pAgent.agencyname != DEFAULT_DROPDOWN_STATUS.ALL) {

                        this.isSingleAgent = true
                        this.agent = this.getAgentDetails(pAgent)

                       


                        
                        this.selAgentObj = cloneDeep(this.agent);

                    } else {
                        this.isSingleAgent = false;
                        let count = 0;
                        this.lsPostpaidStatements = JSON.parse(
                            JSON.stringify(this.postpaidStmntRes)
                        );
                        for (let i = 0; i < this.lsPostpaidStatements.length; i++) {
                            count = count + this.lsPostpaidStatements[i].list.length;
                        }
                        this.cSystemDepositWatchList.filteredlistCount = count;

                    }


                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in onAllAgentChange",
                        err.toString(),
                        "onAllAgentChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            resetNewDueAmount() {
                try {
                  if(BaseConfiguration.isDebug) console.log("resetNewDueAmount");
                 
                      if(this.agent && this.agent.list && this.agent.list.length)
                        {
                            this.agent.list.forEach(stmnt=>{
                            
                            Object.keys(stmnt).forEach(key=>{

                                if(typeof stmnt[key]=='object')

                                {


                                    
                                    stmnt[key].newBalAmount =stmnt[key].balanceDue;
                                }
                            })
                            })
                        }
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_SYSTEM_DEPOSIT,
                          "error in resetNewDueAmount",
                          err.toString(),
                          "resetNewDueAmount",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
               
                }, 

            onAgentChange(pAgent) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onAgentChange");
                    this.selStatement = null;
                    this.isShowStatementDp=false;
                    let that = this;
                         Vue.nextTick(function () {
                            that.isShowStatementDp = true;
                        });
                    this.SET_OVER_DUE_FILTER(false);
                    this.postpaid.isPastDueDate = false;
                    this.clearPaymentStatements();

                    if (this.isViewOnly) {
                        this.lsPrintableStatements = [];
                    }

                    if (pAgent && pAgent.agencyName != DEFAULT_DROPDOWN_STATUS.ALL) {
                        this.isSingleAgent = true;
                        this.paymentDet.isAll = false
                        pAgent = this.getAgentDetails(pAgent);
                        this.selAgentObj = cloneDeep(pAgent);
                        this.showExtendDueDateModal = false;
                        this.resetNewDueAmount();

                     
                    } else {
                        this.isSingleAgent = false;
                        let count = 0;
                        this.lsPostpaidStatements = JSON.parse(
                            JSON.stringify(this.postpaidStmntRes)
                        );


                        for (let i = 0; i < this.lsPostpaidStatements.length; i++) {
                            count = count + this.lsPostpaidStatements[i].list.length;
                        }
                        this.cSystemDepositWatchList.filteredlistCount = count;

                    }

                    this.hideAllModals()
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in onAgentChange",
                        err.toString(),
                        "onAgentChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getFinalReportDate() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getFinalReportDate");

                    retValue = addMonths(
                        this.getInitialReportDate(),
                        BaseConfiguration.defaultPostPaidReportDur
                    );
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getFinalReportDate",
                        err.toString(),
                        "getFinalReportDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getStatementCurrencies(pStatement) {
                let retValue = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("getStatementCurrencies");
                    pStatement = cloneData(pStatement);
                    if (pStatement) {
                        if (
                            pStatement.hasOwnProperty("fromDate") &&
                            pStatement.hasOwnProperty("toDate")
                        ) {
                            delete pStatement.fromDate;
                            delete pStatement.toDate;
                        }

                        Object.keys(pStatement).forEach(currKey => {
                            let currency = {};

                            Object.keys(pStatement[currKey]).forEach(key => {
                                currency[key] = pStatement[currKey][key];
                            });
                            currency.name = currKey;
                            retValue.push(cloneData(currency));
                        });
                    } else {
                        retValue = [];
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getStatementCurrencies",
                        err.toString(),
                        "getStatementCurrencies",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            async getPostPaidStatements(pB2BId, pFromDate, pToDate, pStatus) {
                let retValue = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("getPostPaidStatements");

                    let postpaidStmntReq = apiGetPostPaidStatementList.buildRequest(
                        null,
                        this.$options.filters.formatDate(pFromDate, DATE_TIME_FORMAT.API_DATE_FORMAT),
                        this.$options.filters.formatDate(pToDate, DATE_TIME_FORMAT.API_DATE_FORMAT),
                        pStatus
                    );

                    if (postpaidStmntReq) {


                        let postpaidStmntRes = await apiGetPostPaidStatementList.getResponse(
                            postpaidStmntReq
                        );
                        if (VALIDATE_SUCCESS_RES(postpaidStmntRes)) {//VALIDATE_SUCCESS_RES(postpaidStmntRes)
                            Object.keys(postpaidStmntRes.data.data.statementList).forEach(key => {
                                retValue.push(postpaidStmntRes.data.data.statementList[key]);
                            });


                            if (!pB2BId) {
                                this.postpaidStmntRes = cloneData(retValue);
                                
                            }
                            this.postPaidCount = postpaidStmntRes.data.data.count;
                            this.alertValue = null;
                        } else {
                            let error = getErrorMessage(postpaidStmntRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid postpaid Statement  request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPostPaidStatements",
                        err.toString(),
                        "getPostPaidStatements",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            formatDate(pDate) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("formatDate");
                    if (pDate != null) {
                        retValue = this.$options.filters.formatDate(pDate, "DD-MM-YYYY");
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in formatDate",
                        err.toString(),
                        "formatDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getAllPostPaidAgents(pPostPaidStmntRes) {
                let retValue = [];
                try {
                    if (BaseConfiguration.isDebug) console.log("getAllPostPaidAgents");
                    if (pPostPaidStmntRes && pPostPaidStmntRes.length) {
                        if (this.isViewOnly) {
                            this.agent = {agencyname: DEFAULT_DROPDOWN_STATUS.ALL, b2bid: null};

                        } else {
                            this.agent = {agencyName: DEFAULT_DROPDOWN_STATUS.ALL, b2bid: null};

                        }
                        pPostPaidStmntRes.unshift(this.agent);
                        retValue = cloneData(pPostPaidStmntRes);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYSTEM_DEPOSIT,
                        "error in getAllPostPaidAgents",
                        err.toString(),
                        "getAllPostPaidAgents",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            getPropToSortAgents(pAgent) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getPropToSortAgents");
                    if (pAgent.agencyName) {
                        return pAgent.agencyName.toLowerCase();

                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SYSTEM_DEPOSIT,
                        "error in getPropToSortAgents",
                        err.toString(),
                        "getPropToSortAgents",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
        },

        mounted() {
            try {
                if (BaseConfiguration.isDebug) console.log("mounted");

                this.lsPostpaidTypes = this.getPostPaidTypes();
            } catch (err) {
                let body = Logger.buildRequest(
                    FILE_NAME.C_SYSTEM_DEPOSIT,
                    "error in mounted",
                    err.toString(),
                    "mounted",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },
        beforeCreate() {
            addClassToBody(COMPONENT_NAME.C_SYSTEM_DEPOSIT);
        },

        beforeDestroy() {
            this.SET_OVER_DUE_FILTER(false);
            removeClassBody();
        },


        async created() {
            try {
















                if (BaseConfiguration.isDebug) console.log("created");
                this.lsSystemExchangeRate = await this.getAllExchngRate();

                (this.postpaidStatement.fromDate = this.getInitialReportDate()),
                    (this.postpaidStatement.toDate = this.getFinalReportDate()),
                    (this.lsPostpaidStatements = await this.getPostPaidStatements(
                        null,
                        this.postpaidStatement.fromDate,
                        this.postpaidStatement.toDate,
                        this.isViewOnly

                            ? POSTPAID_STATEMENT_STATUS.ALL : POSTPAID_STATEMENT_STATUS.DEPOSIT
                    ));
                this.sortStatements();

                this.lsPostpaidStatements = OrderByList(this.lsPostpaidStatements, this.getPropToSortAgents, ORDER.ASC);

                this.lsAllPostPaidAgents = this.getAllPostPaidAgents(
                    cloneData(this.lsPostpaidStatements)
                );
                this.lsStatementNo = this.getStatementNoOptionLs();
                if (this.GET_OVER_DUE_FILTER) {
                    this.postpaid.isPastDueDate = true;
                    this.filterStatements(this.postpaid);
                }


            } catch (err) {
                let body = Logger.buildRequest(
                    FILE_NAME.C_SYSTEM_DEPOSIT,
                    "error in created",
                    err.toString(),
                    "created",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        }
    }

</script>

<style>
    .xxxx
    .max-width-1000px:last-child()
    .card.assign.pricing-card.sticky-title-bar {
        z-index: 0;
    }

    /*.highLight {*/
    /*  background-color: red;*/
    /*}*/

    .updown {
        background-color: tomato;
    }
    .flip-list-move {
  transition:  all 1s;
}

.flip-list-enter-active,
    .flip-list-leave-active{
        transition: all 1s;
    }
    .flip-list-enter, .flip-list-leave-to /* .list-leave-active below version 2.1.8 */
    {
        opacity: 0;
        transform: translateY(50px);
    }
</style>
